var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _path300, _path301, _path302, _path303, _path304, _path305, _path306, _path307, _path308, _path309, _path310, _path311, _path312, _path313, _path314, _path315, _path316, _path317, _path318, _path319, _path320, _path321, _path322, _path323, _path324, _path325, _path326, _path327, _path328, _path329, _path330, _path331, _path332, _path333, _path334, _path335, _path336, _path337, _path338, _path339, _path340, _path341, _path342, _path343, _path344, _path345, _path346, _path347, _path348, _path349, _path350, _path351, _path352, _path353, _path354, _path355, _path356, _path357, _path358, _path359, _path360, _path361, _path362, _path363, _path364, _path365, _path366, _path367, _path368, _path369, _path370, _path371, _path372, _path373, _path374, _path375, _path376, _path377, _path378, _path379, _path380, _path381, _path382, _path383, _path384, _path385, _path386, _path387, _path388, _path389, _path390, _path391, _path392, _path393, _path394, _path395, _path396, _path397, _path398, _path399, _path400, _path401, _path402, _path403, _path404, _path405, _path406, _path407, _path408, _path409, _path410, _path411, _path412, _path413, _path414, _path415, _path416, _path417, _path418, _path419, _path420, _path421, _path422, _path423, _path424, _path425, _path426, _path427, _path428, _path429, _path430, _path431, _path432, _path433, _path434, _path435, _path436, _path437, _path438, _path439, _path440, _path441, _path442, _path443, _path444, _path445, _path446, _path447, _path448, _path449, _path450, _path451, _path452, _path453, _path454, _path455, _path456, _path457, _path458, _path459, _path460, _path461, _path462, _path463, _path464, _path465, _path466, _path467, _path468, _path469, _path470, _path471, _path472, _path473, _path474, _path475, _path476, _path477, _path478, _path479, _path480, _path481, _path482, _path483, _path484, _path485, _path486, _path487, _path488, _path489, _path490, _path491, _path492, _path493, _path494, _path495, _path496, _path497, _path498, _path499, _path500, _path501, _path502, _path503, _path504, _path505, _path506, _path507, _path508, _path509, _path510, _path511, _path512, _path513, _path514, _path515, _path516, _path517, _path518, _path519, _path520, _path521, _path522, _path523, _path524, _path525, _path526, _path527, _path528, _path529, _path530, _path531, _path532, _path533, _path534, _path535, _path536, _path537, _path538, _path539, _path540, _path541, _path542, _path543, _path544, _path545, _path546, _path547, _path548, _path549, _path550, _path551, _path552, _path553, _path554, _path555, _path556, _path557, _path558, _path559, _path560, _path561, _path562, _path563, _path564, _path565, _path566, _path567, _path568, _path569, _path570, _path571, _path572, _path573, _path574, _path575, _path576, _path577, _path578, _path579, _path580, _path581, _path582, _path583, _path584, _path585, _path586, _path587, _path588, _path589, _path590, _path591, _path592, _path593, _path594, _path595, _path596, _path597, _path598, _path599, _path600, _path601, _path602, _path603, _path604, _path605, _path606, _path607, _path608, _path609, _path610, _path611, _path612, _path613, _path614, _path615, _path616, _path617, _path618, _path619, _path620, _path621, _path622, _path623, _path624, _path625, _path626, _path627, _path628, _path629, _path630, _path631, _path632, _path633, _path634, _path635, _path636, _path637, _path638, _path639, _path640, _path641, _path642, _path643, _path644, _path645, _path646, _path647, _path648, _path649, _path650, _path651, _path652, _path653, _path654, _path655, _path656, _path657, _path658, _path659, _path660, _path661, _path662, _path663, _path664, _path665, _path666, _path667, _path668, _path669, _path670, _path671, _path672, _path673, _path674, _path675, _path676, _path677, _path678, _path679, _path680, _path681, _path682, _path683, _path684, _path685, _path686, _path687, _path688, _path689, _path690, _path691, _path692, _path693, _path694, _path695, _path696, _path697, _path698, _path699, _path700, _path701, _path702, _path703, _path704, _path705, _path706, _path707, _path708, _path709, _path710, _path711, _path712, _path713, _path714, _path715, _path716, _path717, _path718, _path719, _path720, _path721, _path722, _path723, _path724, _path725, _path726, _path727, _path728, _path729, _path730, _path731, _path732, _path733, _path734, _path735, _path736, _path737, _path738, _path739, _path740, _path741, _path742, _path743, _path744, _path745, _path746, _path747, _path748, _path749, _path750, _path751, _path752, _path753, _path754, _path755, _g, _rect, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgApple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2312_2)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M200 0H0V200H200V0Z",
    fill: "#F7F9FA",
    fillOpacity: 0.8
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2312_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 18,
    y: 18,
    width: 164,
    height: 164
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20 54C21.1046 54 22 53.1046 22 52C22 50.8954 21.1046 50 20 50C18.8954 50 18 50.8954 18 52C18 53.1046 18.8954 54 20 54Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22 66V62H20C19.4696 62 18.9609 62.2107 18.5858 62.5858C18.2107 62.9609 18 63.4696 18 64C18 64.5304 18.2107 65.0391 18.5858 65.4142C18.9609 65.7893 19.4696 66 20 66",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18 74H22V70H20C19.4696 70 18.9609 70.2107 18.5858 70.5858C18.2107 70.9609 18 71.4696 18 72",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M22 78V74H18V76C18 76.5304 18.2107 77.0391 18.5858 77.4142C18.9609 77.7893 19.4696 78 20 78",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M18 86H22V84C22 83.4696 21.7893 82.9609 21.4142 82.5858C21.0391 82.2107 20.5304 82 20 82C19.4696 82 18.9609 82.2107 18.5858 82.5858C18.2107 82.9609 18 83.4696 18 84",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M22 90V86H18V88C18 88.5304 18.2107 89.0391 18.5858 89.4142C18.9609 89.7893 19.4696 90 20 90",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M20 98C21.1046 98 22 97.1046 22 96C22 94.8954 21.1046 94 20 94C18.8954 94 18 94.8954 18 96C18 97.1046 18.8954 98 20 98Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M18 110H22V108C22 107.47 21.7893 106.961 21.4142 106.586C21.0391 106.211 20.5304 106 20 106C19.4696 106 18.9609 106.211 18.5858 106.586C18.2107 106.961 18 107.47 18 108",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M22 114V110H18V112C18 112.53 18.2107 113.039 18.5858 113.414C18.9609 113.789 19.4696 114 20 114",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M22 126V122H20C19.4696 122 18.9609 122.211 18.5858 122.586C18.2107 122.961 18 123.47 18 124C18 124.53 18.2107 125.039 18.5858 125.414C18.9609 125.789 19.4696 126 20 126",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M22 134V130H20C19.4696 130 18.9609 130.211 18.5858 130.586C18.2107 130.961 18 131.47 18 132C18 132.53 18.2107 133.039 18.5858 133.414C18.9609 133.789 19.4696 134 20 134",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M18 142H22V140C22 139.47 21.7893 138.961 21.4142 138.586C21.0391 138.211 20.5304 138 20 138C19.4696 138 18.9609 138.211 18.5858 138.586C18.2107 138.961 18 139.47 18 140",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M22 142H18V146H22V142Z",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M22 150V146H18V148C18 148.53 18.2107 149.039 18.5858 149.414C18.9609 149.789 19.4696 150 20 150",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M24 58C25.1046 58 26 57.1046 26 56C26 54.8954 25.1046 54 24 54C22.8954 54 22 54.8954 22 56C22 57.1046 22.8954 58 24 58Z",
    fill: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M22 62V66H24C24.5304 66 25.0391 65.7893 25.4142 65.4142C25.7893 65.0391 26 64.5304 26 64C26 63.4696 25.7893 62.9609 25.4142 62.5858C25.0391 62.2107 24.5304 62 24 62",
    fill: "white"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M22 70V74H26V72C26 71.4696 25.7893 70.9609 25.4142 70.5858C25.0391 70.2107 24.5304 70 24 70",
    fill: "white"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M26 74H22V78H24C24.5304 78 25.0391 77.7893 25.4142 77.4142C25.7893 77.0391 26 76.5304 26 76",
    fill: "white"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M26 86H22V90H26V86Z",
    fill: "white"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M26 90H22V92C22 92.5304 22.2107 93.0391 22.5858 93.4142C22.9609 93.7893 23.4696 94 24 94C24.5304 94 25.0391 93.7893 25.4142 93.4142C25.7893 93.0391 26 92.5304 26 92",
    fill: "white"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M22 110V114H24C24.5304 114 25.0391 113.789 25.4142 113.414C25.7893 113.039 26 112.53 26 112C26 111.47 25.7893 110.961 25.4142 110.586C25.0391 110.211 24.5304 110 24 110",
    fill: "white"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M26 122H22V126H26V122Z",
    fill: "white"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M26 126H22V130H26V126Z",
    fill: "white"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M26 130H22V134H26V130Z",
    fill: "white"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M26 146H22V150H26V146Z",
    fill: "white"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M30 62V58H28C27.4696 58 26.9609 58.2107 26.5858 58.5858C26.2107 58.9609 26 59.4696 26 60C26 60.5304 26.2107 61.0391 26.5858 61.4142C26.9609 61.7893 27.4696 62 28 62",
    fill: "white"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M28 82C29.1046 82 30 81.1046 30 80C30 78.8954 29.1046 78 28 78C26.8954 78 26 78.8954 26 80C26 81.1046 26.8954 82 28 82Z",
    fill: "white"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M30 86H26V90H30V86Z",
    fill: "white"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M28 102C29.1046 102 30 101.105 30 100C30 98.8954 29.1046 98 28 98C26.8954 98 26 98.8954 26 100C26 101.105 26.8954 102 28 102Z",
    fill: "white"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M28 110C29.1046 110 30 109.105 30 108C30 106.895 29.1046 106 28 106C26.8954 106 26 106.895 26 108C26 109.105 26.8954 110 28 110Z",
    fill: "white"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M28 118C29.1046 118 30 117.105 30 116C30 114.895 29.1046 114 28 114C26.8954 114 26 114.895 26 116C26 117.105 26.8954 118 28 118Z",
    fill: "white"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M26 122V126H30V124C30 123.47 29.7893 122.961 29.4142 122.586C29.0391 122.211 28.5304 122 28 122",
    fill: "white"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M30 126H26V130H30V126Z",
    fill: "white"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M30 130H26V134H28C28.5304 134 29.0391 133.789 29.4142 133.414C29.7893 133.039 30 132.53 30 132",
    fill: "white"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M30 142V138H28C27.4696 138 26.9609 138.211 26.5858 138.586C26.2107 138.961 26 139.47 26 140C26 140.53 26.2107 141.039 26.5858 141.414C26.9609 141.789 27.4696 142 28 142",
    fill: "white"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M30 146H26V150H30V146Z",
    fill: "white"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M30 58H34V56C34 55.4696 33.7893 54.9609 33.4142 54.5858C33.0391 54.2107 32.5304 54 32 54C31.4696 54 30.9609 54.2107 30.5858 54.5858C30.2107 54.9609 30 55.4696 30 56",
    fill: "white"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M34 58H30V62H32C32.5304 62 33.0391 61.7893 33.4142 61.4142C33.7893 61.0391 34 60.5304 34 60",
    fill: "white"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M30 70H34V66H32C31.4696 66 30.9609 66.2107 30.5858 66.5858C30.2107 66.9609 30 67.4696 30 68",
    fill: "white"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M34 70H30V72C30 72.5304 30.2107 73.0391 30.5858 73.4142C30.9609 73.7893 31.4696 74 32 74C32.5304 74 33.0391 73.7893 33.4142 73.4142C33.7893 73.0391 34 72.5304 34 72",
    fill: "white"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M30 86V90H34V88C34 87.4696 33.7893 86.9609 33.4142 86.5858C33.0391 86.2107 32.5304 86 32 86",
    fill: "white"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M34 90H30V94H34V90Z",
    fill: "white"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M34 94H30V96C30 96.5304 30.2107 97.0391 30.5858 97.4142C30.9609 97.7893 31.4696 98 32 98C32.5304 98 33.0391 97.7893 33.4142 97.4142C33.7893 97.0391 34 96.5304 34 96",
    fill: "white"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M34 106V102H32C31.4696 102 30.9609 102.211 30.5858 102.586C30.2107 102.961 30 103.47 30 104C30 104.53 30.2107 105.039 30.5858 105.414C30.9609 105.789 31.4696 106 32 106",
    fill: "white"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M32 122C33.1046 122 34 121.105 34 120C34 118.895 33.1046 118 32 118C30.8954 118 30 118.895 30 120C30 121.105 30.8954 122 32 122Z",
    fill: "white"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M30 138H34V136C34 135.47 33.7893 134.961 33.4142 134.586C33.0391 134.211 32.5304 134 32 134C31.4696 134 30.9609 134.211 30.5858 134.586C30.2107 134.961 30 135.47 30 136",
    fill: "white"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M34 138H30V142H34V138Z",
    fill: "white"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M34 142H30V146H34V142Z",
    fill: "white"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M34 146H30V150H34V146Z",
    fill: "white"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M38 54V50H36C35.4696 50 34.9609 50.2107 34.5858 50.5858C34.2107 50.9609 34 51.4696 34 52C34 52.5304 34.2107 53.0391 34.5858 53.4142C34.9609 53.7893 35.4696 54 36 54",
    fill: "white"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M34 66V70H36C36.5304 70 37.0391 69.7893 37.4142 69.4142C37.7893 69.0391 38 68.5304 38 68C38 67.4696 37.7893 66.9609 37.4142 66.5858C37.0391 66.2107 36.5304 66 36 66",
    fill: "white"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M38 102H34V106H38V102Z",
    fill: "white"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M38 114V110H36C35.4696 110 34.9609 110.211 34.5858 110.586C34.2107 110.961 34 111.47 34 112C34 112.53 34.2107 113.039 34.5858 113.414C34.9609 113.789 35.4696 114 36 114",
    fill: "white"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M36 126C37.1046 126 38 125.105 38 124C38 122.895 37.1046 122 36 122C34.8954 122 34 122.895 34 124C34 125.105 34.8954 126 36 126Z",
    fill: "white"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M36 134C37.1046 134 38 133.105 38 132C38 130.895 37.1046 130 36 130C34.8954 130 34 130.895 34 132C34 133.105 34.8954 134 36 134Z",
    fill: "white"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M34 142V146H38V144C38 143.47 37.7893 142.961 37.4142 142.586C37.0391 142.211 36.5304 142 36 142",
    fill: "white"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M38 146H34V150H38V146Z",
    fill: "white"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M42 50H38V54H42V50Z",
    fill: "white"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M42 54H38V58H42V54Z",
    fill: "white"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M42 62V58H38V60C38 60.5304 38.2107 61.0391 38.5858 61.4142C38.9609 61.7893 39.4696 62 40 62",
    fill: "white"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M40 74C41.1046 74 42 73.1046 42 72C42 70.8954 41.1046 70 40 70C38.8954 70 38 70.8954 38 72C38 73.1046 38.8954 74 40 74Z",
    fill: "white"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M38 94H42V90H40C39.4696 90 38.9609 90.2107 38.5858 90.5858C38.2107 90.9609 38 91.4696 38 92",
    fill: "white"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M42 94H38V98H42V94Z",
    fill: "white"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M42 98H38V102H42V98Z",
    fill: "white"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M42 102H38V106H42V102Z",
    fill: "white"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M42 106H38V110H42V106Z",
    fill: "white"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M42 110H38V114H42V110Z",
    fill: "white"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M42 118V114H38V116C38 116.53 38.2107 117.039 38.5858 117.414C38.9609 117.789 39.4696 118 40 118",
    fill: "white"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M40 130C41.1046 130 42 129.105 42 128C42 126.895 41.1046 126 40 126C38.8954 126 38 126.895 38 128C38 129.105 38.8954 130 40 130Z",
    fill: "white"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M42 142V138H40C39.4696 138 38.9609 138.211 38.5858 138.586C38.2107 138.961 38 139.47 38 140C38 140.53 38.2107 141.039 38.5858 141.414C38.9609 141.789 39.4696 142 40 142",
    fill: "white"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M42 146H38V150H42V146Z",
    fill: "white"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M42 50V54H44C44.5304 54 45.0391 53.7893 45.4142 53.4142C45.7893 53.0391 46 52.5304 46 52C46 51.4696 45.7893 50.9609 45.4142 50.5858C45.0391 50.2107 44.5304 50 44 50",
    fill: "white"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M42 58V62H44C44.5304 62 45.0391 61.7893 45.4142 61.4142C45.7893 61.0391 46 60.5304 46 60C46 59.4696 45.7893 58.9609 45.4142 58.5858C45.0391 58.2107 44.5304 58 44 58",
    fill: "white"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M44 70C45.1046 70 46 69.1046 46 68C46 66.8954 45.1046 66 44 66C42.8954 66 42 66.8954 42 68C42 69.1046 42.8954 70 44 70Z",
    fill: "white"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M46 78V74H44C43.4696 74 42.9609 74.2107 42.5858 74.5858C42.2107 74.9609 42 75.4696 42 76C42 76.5304 42.2107 77.0391 42.5858 77.4142C42.9609 77.7893 43.4696 78 44 78",
    fill: "white"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M44 86C45.1046 86 46 85.1046 46 84C46 82.8954 45.1046 82 44 82C42.8954 82 42 82.8954 42 84C42 85.1046 42.8954 86 44 86Z",
    fill: "white"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M46 90H42V94H46V90Z",
    fill: "white"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M46 98H42V102H46V98Z",
    fill: "white"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M42 106V110H44C44.5304 110 45.0391 109.789 45.4142 109.414C45.7893 109.039 46 108.53 46 108C46 107.47 45.7893 106.961 45.4142 106.586C45.0391 106.211 44.5304 106 44 106",
    fill: "white"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M42 114V118H44C44.5304 118 45.0391 117.789 45.4142 117.414C45.7893 117.039 46 116.53 46 116C46 115.47 45.7893 114.961 45.4142 114.586C45.0391 114.211 44.5304 114 44 114",
    fill: "white"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M46 126V122H44C43.4696 122 42.9609 122.211 42.5858 122.586C42.2107 122.961 42 123.47 42 124C42 124.53 42.2107 125.039 42.5858 125.414C42.9609 125.789 43.4696 126 44 126",
    fill: "white"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M44 134C45.1046 134 46 133.105 46 132C46 130.895 45.1046 130 44 130C42.8954 130 42 130.895 42 132C42 133.105 42.8954 134 44 134Z",
    fill: "white"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M42 138V142H44C44.5304 142 45.0391 141.789 45.4142 141.414C45.7893 141.039 46 140.53 46 140C46 139.47 45.7893 138.961 45.4142 138.586C45.0391 138.211 44.5304 138 44 138",
    fill: "white"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M42 146V150H44C44.5304 150 45.0391 149.789 45.4142 149.414C45.7893 149.039 46 148.53 46 148C46 147.47 45.7893 146.961 45.4142 146.586C45.0391 146.211 44.5304 146 44 146",
    fill: "white"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M50 58V54H48C47.4696 54 46.9609 54.2107 46.5858 54.5858C46.2107 54.9609 46 55.4696 46 56C46 56.5304 46.2107 57.0391 46.5858 57.4142C46.9609 57.7893 47.4696 58 48 58",
    fill: "white"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M50 74H46V78H50V74Z",
    fill: "white"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M46 90H50V88C50 87.4696 49.7893 86.9609 49.4142 86.5858C49.0391 86.2107 48.5304 86 48 86C47.4696 86 46.9609 86.2107 46.5858 86.5858C46.2107 86.9609 46 87.4696 46 88",
    fill: "white"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M50 90H46V94H48C48.5304 94 49.0391 93.7893 49.4142 93.4142C49.7893 93.0391 50 92.5304 50 92",
    fill: "white"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M50 98H46V102H50V98Z",
    fill: "white"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M50 106V102H46V104C46 104.53 46.2107 105.039 46.5858 105.414C46.9609 105.789 47.4696 106 48 106",
    fill: "white"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M50 122H46V126H50V122Z",
    fill: "white"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M50 26H54V24C54 23.4696 53.7893 22.9609 53.4142 22.5858C53.0391 22.2107 52.5304 22 52 22C51.4696 22 50.9609 22.2107 50.5858 22.5858C50.2107 22.9609 50 23.4696 50 24",
    fill: "white"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M54 26H50V30H54V26Z",
    fill: "white"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M54 30H50V34H54V30Z",
    fill: "white"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M54 34H50V38H54V34Z",
    fill: "white"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M54 38H50V42H54V38Z",
    fill: "white"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M54 42H50V46H54V42Z",
    fill: "white"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M54 50V46H50V48C50 48.5304 50.2107 49.0391 50.5858 49.4142C50.9609 49.7893 51.4696 50 52 50",
    fill: "white"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M54 54H50V58H54V54Z",
    fill: "white"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M54 62V58H50V60C50 60.5304 50.2107 61.0391 50.5858 61.4142C50.9609 61.7893 51.4696 62 52 62",
    fill: "white"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M54 70V66H52C51.4696 66 50.9609 66.2107 50.5858 66.5858C50.2107 66.9609 50 67.4696 50 68C50 68.5304 50.2107 69.0391 50.5858 69.4142C50.9609 69.7893 51.4696 70 52 70",
    fill: "white"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M50 74V78H52C52.5304 78 53.0391 77.7893 53.4142 77.4142C53.7893 77.0391 54 76.5304 54 76C54 75.4696 53.7893 74.9609 53.4142 74.5858C53.0391 74.2107 52.5304 74 52 74",
    fill: "white"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M50 98H54V94H52C51.4696 94 50.9609 94.2107 50.5858 94.5858C50.2107 94.9609 50 95.4696 50 96",
    fill: "white"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M54 98H50V102H54V98Z",
    fill: "white"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M54 102H50V106H52C52.5304 106 53.0391 105.789 53.4142 105.414C53.7893 105.039 54 104.53 54 104",
    fill: "white"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M54 114V110H52C51.4696 110 50.9609 110.211 50.5858 110.586C50.2107 110.961 50 111.47 50 112C50 112.53 50.2107 113.039 50.5858 113.414C50.9609 113.789 51.4696 114 52 114",
    fill: "white"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M50 122H54V120C54 119.47 53.7893 118.961 53.4142 118.586C53.0391 118.211 52.5304 118 52 118C51.4696 118 50.9609 118.211 50.5858 118.586C50.2107 118.961 50 119.47 50 120",
    fill: "white"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M54 122H50V126H54V122Z",
    fill: "white"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M54 126H50V128C50 128.53 50.2107 129.039 50.5858 129.414C50.9609 129.789 51.4696 130 52 130C52.5304 130 53.0391 129.789 53.4142 129.414C53.7893 129.039 54 128.53 54 128",
    fill: "white"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M52 138C53.1046 138 54 137.105 54 136C54 134.895 53.1046 134 52 134C50.8954 134 50 134.895 50 136C50 137.105 50.8954 138 52 138Z",
    fill: "white"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M50 162H54V158H52C51.4696 158 50.9609 158.211 50.5858 158.586C50.2107 158.961 50 159.47 50 160",
    fill: "white"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M54 166V162H50V164C50 164.53 50.2107 165.039 50.5858 165.414C50.9609 165.789 51.4696 166 52 166",
    fill: "white"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M54 182V178H52C51.4696 178 50.9609 178.211 50.5858 178.586C50.2107 178.961 50 179.47 50 180C50 180.53 50.2107 181.039 50.5858 181.414C50.9609 181.789 51.4696 182 52 182",
    fill: "white"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M58 34H54V38H58V34Z",
    fill: "white"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M58 38H54V42H58V38Z",
    fill: "white"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M58 46H54V50H58V46Z",
    fill: "white"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M58 50H54V54H58V50Z",
    fill: "white"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M58 54H54V58H58V54Z",
    fill: "white"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M58 58H54V62H58V58Z",
    fill: "white"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M58 62H54V66H58V62Z",
    fill: "white"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M58 66H54V70H58V66Z",
    fill: "white"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M58 70H54V72C54 72.5304 54.2107 73.0391 54.5858 73.4142C54.9609 73.7893 55.4696 74 56 74C56.5304 74 57.0391 73.7893 57.4142 73.4142C57.7893 73.0391 58 72.5304 58 72",
    fill: "white"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M54 94V98H58V96C58 95.4696 57.7893 94.9609 57.4142 94.5858C57.0391 94.2107 56.5304 94 56 94",
    fill: "white"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M58 98H54V102H56C56.5304 102 57.0391 101.789 57.4142 101.414C57.7893 101.039 58 100.53 58 100",
    fill: "white"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M54 110H58V108C58 107.47 57.7893 106.961 57.4142 106.586C57.0391 106.211 56.5304 106 56 106C55.4696 106 54.9609 106.211 54.5858 106.586C54.2107 106.961 54 107.47 54 108",
    fill: "white"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M58 110H54V114H56C56.5304 114 57.0391 113.789 57.4142 113.414C57.7893 113.039 58 112.53 58 112",
    fill: "white"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M58 122H54V126H58V122Z",
    fill: "white"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M56 134C57.1046 134 58 133.105 58 132C58 130.895 57.1046 130 56 130C54.8954 130 54 130.895 54 132C54 133.105 54.8954 134 56 134Z",
    fill: "white"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M54 146H58V144C58 143.47 57.7893 142.961 57.4142 142.586C57.0391 142.211 56.5304 142 56 142C55.4696 142 54.9609 142.211 54.5858 142.586C54.2107 142.961 54 143.47 54 144",
    fill: "white"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M58 146H54V150H58V146Z",
    fill: "white"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M58 150H54V154H58V150Z",
    fill: "white"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M58 154H54V158H58V154Z",
    fill: "white"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M58 158H54V162H58V158Z",
    fill: "white"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M58 162H54V166H58V162Z",
    fill: "white"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M54 174H58V172C58 171.47 57.7893 170.961 57.4142 170.586C57.0391 170.211 56.5304 170 56 170C55.4696 170 54.9609 170.211 54.5858 170.586C54.2107 170.961 54 171.47 54 172",
    fill: "white"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M58 174H54V178H58V174Z",
    fill: "white"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M58 178H54V182H56C56.5304 182 57.0391 181.789 57.4142 181.414C57.7893 181.039 58 180.53 58 180",
    fill: "white"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M58 22H62V18H60C59.4696 18 58.9609 18.2107 58.5858 18.5858C58.2107 18.9609 58 19.4696 58 20",
    fill: "white"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M62 26V22H58V24C58 24.5304 58.2107 25.0391 58.5858 25.4142C58.9609 25.7893 59.4696 26 60 26",
    fill: "white"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M58 34H62V30H60C59.4696 30 58.9609 30.2107 58.5858 30.5858C58.2107 30.9609 58 31.4696 58 32",
    fill: "white"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M62 34H58V38H62V34Z",
    fill: "white"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M62 38H58V42H62V38Z",
    fill: "white"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M62 42H58V46H62V42Z",
    fill: "white"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M62 46H58V50H62V46Z",
    fill: "white"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M58 54V58H60C60.5304 58 61.0391 57.7893 61.4142 57.4142C61.7893 57.0391 62 56.5304 62 56C62 55.4696 61.7893 54.9609 61.4142 54.5858C61.0391 54.2107 60.5304 54 60 54",
    fill: "white"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M60 106C61.1046 106 62 105.105 62 104C62 102.895 61.1046 102 60 102C58.8954 102 58 102.895 58 104C58 105.105 58.8954 106 60 106Z",
    fill: "white"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M62 122H58V126H62V122Z",
    fill: "white"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M62 126H58V128C58 128.53 58.2107 129.039 58.5858 129.414C58.9609 129.789 59.4696 130 60 130C60.5304 130 61.0391 129.789 61.4142 129.414C61.7893 129.039 62 128.53 62 128",
    fill: "white"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M62 142V138H60C59.4696 138 58.9609 138.211 58.5858 138.586C58.2107 138.961 58 139.47 58 140C58 140.53 58.2107 141.039 58.5858 141.414C58.9609 141.789 59.4696 142 60 142",
    fill: "white"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M62 146H58V150H62V146Z",
    fill: "white"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M62 154H58V158H62V154Z",
    fill: "white"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M62 158H58V162H62V158Z",
    fill: "white"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M62 162H58V166H60C60.5304 166 61.0391 165.789 61.4142 165.414C61.7893 165.039 62 164.53 62 164",
    fill: "white"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M62 18V22H66V20C66 19.4696 65.7893 18.9609 65.4142 18.5858C65.0391 18.2107 64.5304 18 64 18",
    fill: "white"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M66 22H62V26H64C64.5304 26 65.0391 25.7893 65.4142 25.4142C65.7893 25.0391 66 24.5304 66 24",
    fill: "white"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M66 30H62V34H66V30Z",
    fill: "white"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M66 34H62V38H66V34Z",
    fill: "white"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M66 46H62V50H66V46Z",
    fill: "white"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M66 66V62H64C63.4696 62 62.9609 62.2107 62.5858 62.5858C62.2107 62.9609 62 63.4696 62 64C62 64.5304 62.2107 65.0391 62.5858 65.4142C62.9609 65.7893 63.4696 66 64 66",
    fill: "white"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M66 82V78H64C63.4696 78 62.9609 78.2107 62.5858 78.5858C62.2107 78.9609 62 79.4696 62 80C62 80.5304 62.2107 81.0391 62.5858 81.4142C62.9609 81.7893 63.4696 82 64 82",
    fill: "white"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M64 102C65.1046 102 66 101.105 66 100C66 98.8954 65.1046 98 64 98C62.8954 98 62 98.8954 62 100C62 101.105 62.8954 102 64 102Z",
    fill: "white"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M64 110C65.1046 110 66 109.105 66 108C66 106.895 65.1046 106 64 106C62.8954 106 62 106.895 62 108C62 109.105 62.8954 110 64 110Z",
    fill: "white"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M66 122H62V126H66V122Z",
    fill: "white"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M66 134V130H64C63.4696 130 62.9609 130.211 62.5858 130.586C62.2107 130.961 62 131.47 62 132C62 132.53 62.2107 133.039 62.5858 133.414C62.9609 133.789 63.4696 134 64 134",
    fill: "white"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M62 138V142H66V140C66 139.47 65.7893 138.961 65.4142 138.586C65.0391 138.211 64.5304 138 64 138",
    fill: "white"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M66 142H62V146H66V142Z",
    fill: "white"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M66 146H62V150H66V146Z",
    fill: "white"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M62 154V158H66V156C66 155.47 65.7893 154.961 65.4142 154.586C65.0391 154.211 64.5304 154 64 154",
    fill: "white"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M66 158H62V162H64C64.5304 162 65.0391 161.789 65.4142 161.414C65.7893 161.039 66 160.53 66 160",
    fill: "white"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M66 170V166H64C63.4696 166 62.9609 166.211 62.5858 166.586C62.2107 166.961 62 167.47 62 168C62 168.53 62.2107 169.039 62.5858 169.414C62.9609 169.789 63.4696 170 64 170",
    fill: "white"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M66 30H70V26H68C67.4696 26 66.9609 26.2107 66.5858 26.5858C66.2107 26.9609 66 27.4696 66 28",
    fill: "white"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M70 30H66V34H70V30Z",
    fill: "white"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M70 34H66V38H70V34Z",
    fill: "white"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M70 38H66V42H70V38Z",
    fill: "white"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M70 42H66V46H70V42Z",
    fill: "white"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M70 46H66V50H70V46Z",
    fill: "white"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M70 54V50H66V52C66 52.5304 66.2107 53.0391 66.5858 53.4142C66.9609 53.7893 67.4696 54 68 54",
    fill: "white"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M66 62H70V58H68C67.4696 58 66.9609 58.2107 66.5858 58.5858C66.2107 58.9609 66 59.4696 66 60",
    fill: "white"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M70 62H66V66H68C68.5304 66 69.0391 65.7893 69.4142 65.4142C69.7893 65.0391 70 64.5304 70 64",
    fill: "white"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M70 74V70H68C67.4696 70 66.9609 70.2107 66.5858 70.5858C66.2107 70.9609 66 71.4696 66 72C66 72.5304 66.2107 73.0391 66.5858 73.4142C66.9609 73.7893 67.4696 74 68 74",
    fill: "white"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M66 78V82H68C68.5304 82 69.0391 81.7893 69.4142 81.4142C69.7893 81.0391 70 80.5304 70 80C70 79.4696 69.7893 78.9609 69.4142 78.5858C69.0391 78.2107 68.5304 78 68 78",
    fill: "white"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M66 114H70V112C70 111.47 69.7893 110.961 69.4142 110.586C69.0391 110.211 68.5304 110 68 110C67.4696 110 66.9609 110.211 66.5858 110.586C66.2107 110.961 66 111.47 66 112",
    fill: "white"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M70 114H66V118H70V114Z",
    fill: "white"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M70 118H66V122H70V118Z",
    fill: "white"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M70 122H66V126H68C68.5304 126 69.0391 125.789 69.4142 125.414C69.7893 125.039 70 124.53 70 124",
    fill: "white"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M66 130V134H70V132C70 131.47 69.7893 130.961 69.4142 130.586C69.0391 130.211 68.5304 130 68 130",
    fill: "white"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M70 138V134H66V136C66 136.53 66.2107 137.039 66.5858 137.414C66.9609 137.789 67.4696 138 68 138",
    fill: "white"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M70 142H66V146H70V142Z",
    fill: "white"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M70 146H66V150H68C68.5304 150 69.0391 149.789 69.4142 149.414C69.7893 149.039 70 148.53 70 148",
    fill: "white"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M66 166V170H70V168C70 167.47 69.7893 166.961 69.4142 166.586C69.0391 166.211 68.5304 166 68 166",
    fill: "white"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M70 170H66V172C66 172.53 66.2107 173.039 66.5858 173.414C66.9609 173.789 67.4696 174 68 174C68.5304 174 69.0391 173.789 69.4142 173.414C69.7893 173.039 70 172.53 70 172",
    fill: "white"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M70 182V178H68C67.4696 178 66.9609 178.211 66.5858 178.586C66.2107 178.961 66 179.47 66 180C66 180.53 66.2107 181.039 66.5858 181.414C66.9609 181.789 67.4696 182 68 182",
    fill: "white"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M70 26H74V24C74 23.4696 73.7893 22.9609 73.4142 22.5858C73.0391 22.2107 72.5304 22 72 22C71.4696 22 70.9609 22.2107 70.5858 22.5858C70.2107 22.9609 70 23.4696 70 24",
    fill: "white"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M74 26H70V30H72C72.5304 30 73.0391 29.7893 73.4142 29.4142C73.7893 29.0391 74 28.5304 74 28",
    fill: "white"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M70 38V42H72C72.5304 42 73.0391 41.7893 73.4142 41.4142C73.7893 41.0391 74 40.5304 74 40C74 39.4696 73.7893 38.9609 73.4142 38.5858C73.0391 38.2107 72.5304 38 72 38",
    fill: "white"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M70 50V54H74V52C74 51.4696 73.7893 50.9609 73.4142 50.5858C73.0391 50.2107 72.5304 50 72 50",
    fill: "white"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M74 54H70V58H74V54Z",
    fill: "white"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M74 58H70V62H74V58Z",
    fill: "white"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M74 70H70V74H74V70Z",
    fill: "white"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M72 90C73.1046 90 74 89.1046 74 88C74 86.8954 73.1046 86 72 86C70.8954 86 70 86.8954 70 88C70 89.1046 70.8954 90 72 90Z",
    fill: "white"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M72 98C73.1046 98 74 97.1046 74 96C74 94.8954 73.1046 94 72 94C70.8954 94 70 94.8954 70 96C70 97.1046 70.8954 98 72 98Z",
    fill: "white"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M72 106C73.1046 106 74 105.105 74 104C74 102.895 73.1046 102 72 102C70.8954 102 70 102.895 70 104C70 105.105 70.8954 106 72 106Z",
    fill: "white"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M70 134V138H72C72.5304 138 73.0391 137.789 73.4142 137.414C73.7893 137.039 74 136.53 74 136C74 135.47 73.7893 134.961 73.4142 134.586C73.0391 134.211 72.5304 134 72 134",
    fill: "white"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M70 142V146H72C72.5304 146 73.0391 145.789 73.4142 145.414C73.7893 145.039 74 144.53 74 144C74 143.47 73.7893 142.961 73.4142 142.586C73.0391 142.211 72.5304 142 72 142",
    fill: "white"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M70 154H74V150H72C71.4696 150 70.9609 150.211 70.5858 150.586C70.2107 150.961 70 151.47 70 152",
    fill: "white"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M74 154H70V158H74V154Z",
    fill: "white"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M74 158H70V162H74V158Z",
    fill: "white"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M74 162H70V164C70 164.53 70.2107 165.039 70.5858 165.414C70.9609 165.789 71.4696 166 72 166C72.5304 166 73.0391 165.789 73.4142 165.414C73.7893 165.039 74 164.53 74 164",
    fill: "white"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M70 178H74V176C74 175.47 73.7893 174.961 73.4142 174.586C73.0391 174.211 72.5304 174 72 174C71.4696 174 70.9609 174.211 70.5858 174.586C70.2107 174.961 70 175.47 70 176",
    fill: "white"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M74 178H70V182H72C72.5304 182 73.0391 181.789 73.4142 181.414C73.7893 181.039 74 180.53 74 180",
    fill: "white"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M74 34H78V30H76C75.4696 30 74.9609 30.2107 74.5858 30.5858C74.2107 30.9609 74 31.4696 74 32",
    fill: "white"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M78 34H74V36C74 36.5304 74.2107 37.0391 74.5858 37.4142C74.9609 37.7893 75.4696 38 76 38C76.5304 38 77.0391 37.7893 77.4142 37.4142C77.7893 37.0391 78 36.5304 78 36",
    fill: "white"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M76 46C77.1046 46 78 45.1046 78 44C78 42.8954 77.1046 42 76 42C74.8954 42 74 42.8954 74 44C74 45.1046 74.8954 46 76 46Z",
    fill: "white"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M78 54H74V58H78V54Z",
    fill: "white"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M78 58H74V62H78V58Z",
    fill: "white"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M78 70H74V74H78V70Z",
    fill: "white"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M78 130V126H76C75.4696 126 74.9609 126.211 74.5858 126.586C74.2107 126.961 74 127.47 74 128C74 128.53 74.2107 129.039 74.5858 129.414C74.9609 129.789 75.4696 130 76 130",
    fill: "white"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M74 150V154H76C76.5304 154 77.0391 153.789 77.4142 153.414C77.7893 153.039 78 152.53 78 152C78 151.47 77.7893 150.961 77.4142 150.586C77.0391 150.211 76.5304 150 76 150",
    fill: "white"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M78 158H74V162H78V158Z",
    fill: "white"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M74 170H78V166H76C75.4696 166 74.9609 166.211 74.5858 166.586C74.2107 166.961 74 167.47 74 168",
    fill: "white"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M78 170H74V172C74 172.53 74.2107 173.039 74.5858 173.414C74.9609 173.789 75.4696 174 76 174C76.5304 174 77.0391 173.789 77.4142 173.414C77.7893 173.039 78 172.53 78 172",
    fill: "white"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M78 30H82V28C82 27.4696 81.7893 26.9609 81.4142 26.5858C81.0391 26.2107 80.5304 26 80 26C79.4696 26 78.9609 26.2107 78.5858 26.5858C78.2107 26.9609 78 27.4696 78 28",
    fill: "white"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M82 30H78V34H80C80.5304 34 81.0391 33.7893 81.4142 33.4142C81.7893 33.0391 82 32.5304 82 32",
    fill: "white"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M82 54H78V58H82V54Z",
    fill: "white"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M82 58H78V62H80C80.5304 62 81.0391 61.7893 81.4142 61.4142C81.7893 61.0391 82 60.5304 82 60",
    fill: "white"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M78 70V74H82V72C82 71.4696 81.7893 70.9609 81.4142 70.5858C81.0391 70.2107 80.5304 70 80 70",
    fill: "white"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M82 74H78V76C78 76.5304 78.2107 77.0391 78.5858 77.4142C78.9609 77.7893 79.4696 78 80 78C80.5304 78 81.0391 77.7893 81.4142 77.4142C81.7893 77.0391 82 76.5304 82 76",
    fill: "white"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M78 126H82V122H80C79.4696 122 78.9609 122.211 78.5858 122.586C78.2107 122.961 78 123.47 78 124",
    fill: "white"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M82 126H78V130H82V126Z",
    fill: "white"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M82 130H78V132C78 132.53 78.2107 133.039 78.5858 133.414C78.9609 133.789 79.4696 134 80 134C80.5304 134 81.0391 133.789 81.4142 133.414C81.7893 133.039 82 132.53 82 132",
    fill: "white"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M78 142H82V140C82 139.47 81.7893 138.961 81.4142 138.586C81.0391 138.211 80.5304 138 80 138C79.4696 138 78.9609 138.211 78.5858 138.586C78.2107 138.961 78 139.47 78 140",
    fill: "white"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M82 142H78V146H82V142Z",
    fill: "white"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M82 146H78V148C78 148.53 78.2107 149.039 78.5858 149.414C78.9609 149.789 79.4696 150 80 150C80.5304 150 81.0391 149.789 81.4142 149.414C81.7893 149.039 82 148.53 82 148",
    fill: "white"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M78 158H82V156C82 155.47 81.7893 154.961 81.4142 154.586C81.0391 154.211 80.5304 154 80 154C79.4696 154 78.9609 154.211 78.5858 154.586C78.2107 154.961 78 155.47 78 156",
    fill: "white"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "M82 158H78V162H82V158Z",
    fill: "white"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "M78 166V170H80C80.5304 170 81.0391 169.789 81.4142 169.414C81.7893 169.039 82 168.53 82 168C82 167.47 81.7893 166.961 81.4142 166.586C81.0391 166.211 80.5304 166 80 166",
    fill: "white"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "M80 182C81.1046 182 82 181.105 82 180C82 178.895 81.1046 178 80 178C78.8954 178 78 178.895 78 180C78 181.105 78.8954 182 80 182Z",
    fill: "white"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "M84 46C85.1046 46 86 45.1046 86 44C86 42.8954 85.1046 42 84 42C82.8954 42 82 42.8954 82 44C82 45.1046 82.8954 46 84 46Z",
    fill: "white"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "M82 54V58H84C84.5304 58 85.0391 57.7893 85.4142 57.4142C85.7893 57.0391 86 56.5304 86 56C86 55.4696 85.7893 54.9609 85.4142 54.5858C85.0391 54.2107 84.5304 54 84 54",
    fill: "white"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "M86 70V66H84C83.4696 66 82.9609 66.2107 82.5858 66.5858C82.2107 66.9609 82 67.4696 82 68C82 68.5304 82.2107 69.0391 82.5858 69.4142C82.9609 69.7893 83.4696 70 84 70",
    fill: "white"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "M86 122H82V126H86V122Z",
    fill: "white"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "M86 126H82V130H84C84.5304 130 85.0391 129.789 85.4142 129.414C85.7893 129.039 86 128.53 86 128",
    fill: "white"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    d: "M84 138C85.1046 138 86 137.105 86 136C86 134.895 85.1046 134 84 134C82.8954 134 82 134.895 82 136C82 137.105 82.8954 138 84 138Z",
    fill: "white"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    d: "M84 154C85.1046 154 86 153.105 86 152C86 150.895 85.1046 150 84 150C82.8954 150 82 150.895 82 152C82 153.105 82.8954 154 84 154Z",
    fill: "white"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    d: "M86 158H82V162H86V158Z",
    fill: "white"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    d: "M82 174H86V170H84C83.4696 170 82.9609 170.211 82.5858 170.586C82.2107 170.961 82 171.47 82 172",
    fill: "white"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    d: "M86 178V174H82V176C82 176.53 82.2107 177.039 82.5858 177.414C82.9609 177.789 83.4696 178 84 178",
    fill: "white"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    d: "M90 26V22H88C87.4696 22 86.9609 22.2107 86.5858 22.5858C86.2107 22.9609 86 23.4696 86 24C86 24.5304 86.2107 25.0391 86.5858 25.4142C86.9609 25.7893 87.4696 26 88 26",
    fill: "white"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    d: "M88 42C89.1046 42 90 41.1046 90 40C90 38.8954 89.1046 38 88 38C86.8954 38 86 38.8954 86 40C86 41.1046 86.8954 42 88 42Z",
    fill: "white"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    d: "M86 50H90V46H88C87.4696 46 86.9609 46.2107 86.5858 46.5858C86.2107 46.9609 86 47.4696 86 48",
    fill: "white"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    d: "M90 50H86V52C86 52.5304 86.2107 53.0391 86.5858 53.4142C86.9609 53.7893 87.4696 54 88 54C88.5304 54 89.0391 53.7893 89.4142 53.4142C89.7893 53.0391 90 52.5304 90 52",
    fill: "white"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    d: "M86 66H90V62H88C87.4696 62 86.9609 62.2107 86.5858 62.5858C86.2107 62.9609 86 63.4696 86 64",
    fill: "white"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    d: "M90 66H86V70H90V66Z",
    fill: "white"
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    d: "M90 70H86V72C86 72.5304 86.2107 73.0391 86.5858 73.4142C86.9609 73.7893 87.4696 74 88 74C88.5304 74 89.0391 73.7893 89.4142 73.4142C89.7893 73.0391 90 72.5304 90 72",
    fill: "white"
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    d: "M86 122V126H88C88.5304 126 89.0391 125.789 89.4142 125.414C89.7893 125.039 90 124.53 90 124C90 123.47 89.7893 122.961 89.4142 122.586C89.0391 122.211 88.5304 122 88 122",
    fill: "white"
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    d: "M86 142H90V140C90 139.47 89.7893 138.961 89.4142 138.586C89.0391 138.211 88.5304 138 88 138C87.4696 138 86.9609 138.211 86.5858 138.586C86.2107 138.961 86 139.47 86 140",
    fill: "white"
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    d: "M90 142H86V144C86 144.53 86.2107 145.039 86.5858 145.414C86.9609 145.789 87.4696 146 88 146C88.5304 146 89.0391 145.789 89.4142 145.414C89.7893 145.039 90 144.53 90 144",
    fill: "white"
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    d: "M86 158H90V154H88C87.4696 154 86.9609 154.211 86.5858 154.586C86.2107 154.961 86 155.47 86 156",
    fill: "white"
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    d: "M90 158H86V162H90V158Z",
    fill: "white"
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    d: "M90 166V162H86V164C86 164.53 86.2107 165.039 86.5858 165.414C86.9609 165.789 87.4696 166 88 166",
    fill: "white"
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    d: "M86 170V174H90V172C90 171.47 89.7893 170.961 89.4142 170.586C89.0391 170.211 88.5304 170 88 170",
    fill: "white"
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    d: "M90 174H86V178H90V174Z",
    fill: "white"
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    d: "M90 178H86V180C86 180.53 86.2107 181.039 86.5858 181.414C86.9609 181.789 87.4696 182 88 182C88.5304 182 89.0391 181.789 89.4142 181.414C89.7893 181.039 90 180.53 90 180",
    fill: "white"
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    d: "M90 22V26H94V24C94 23.4696 93.7893 22.9609 93.4142 22.5858C93.0391 22.2107 92.5304 22 92 22",
    fill: "white"
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    d: "M94 26H90V28C90 28.5304 90.2107 29.0391 90.5858 29.4142C90.9609 29.7893 91.4696 30 92 30C92.5304 30 93.0391 29.7893 93.4142 29.4142C93.7893 29.0391 94 28.5304 94 28",
    fill: "white"
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    d: "M94 38V34H92C91.4696 34 90.9609 34.2107 90.5858 34.5858C90.2107 34.9609 90 35.4696 90 36C90 36.5304 90.2107 37.0391 90.5858 37.4142C90.9609 37.7893 91.4696 38 92 38",
    fill: "white"
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    d: "M90 46H94V44C94 43.4696 93.7893 42.9609 93.4142 42.5858C93.0391 42.2107 92.5304 42 92 42C91.4696 42 90.9609 42.2107 90.5858 42.5858C90.2107 42.9609 90 43.4696 90 44",
    fill: "white"
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    d: "M94 46H90V50H94V46Z",
    fill: "white"
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    d: "M94 58V54H92C91.4696 54 90.9609 54.2107 90.5858 54.5858C90.2107 54.9609 90 55.4696 90 56C90 56.5304 90.2107 57.0391 90.5858 57.4142C90.9609 57.7893 91.4696 58 92 58",
    fill: "white"
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    d: "M90 62V66H92C92.5304 66 93.0391 65.7893 93.4142 65.4142C93.7893 65.0391 94 64.5304 94 64C94 63.4696 93.7893 62.9609 93.4142 62.5858C93.0391 62.2107 92.5304 62 92 62",
    fill: "white"
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    d: "M92 78C93.1046 78 94 77.1046 94 76C94 74.8954 93.1046 74 92 74C90.8954 74 90 74.8954 90 76C90 77.1046 90.8954 78 92 78Z",
    fill: "white"
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    d: "M90 130H94V126H92C91.4696 126 90.9609 126.211 90.5858 126.586C90.2107 126.961 90 127.47 90 128",
    fill: "white"
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    d: "M94 134V130H90V132C90 132.53 90.2107 133.039 90.5858 133.414C90.9609 133.789 91.4696 134 92 134",
    fill: "white"
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    d: "M90 154H94V152C94 151.47 93.7893 150.961 93.4142 150.586C93.0391 150.211 92.5304 150 92 150C91.4696 150 90.9609 150.211 90.5858 150.586C90.2107 150.961 90 151.47 90 152",
    fill: "white"
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    d: "M94 154H90V158H92C92.5304 158 93.0391 157.789 93.4142 157.414C93.7893 157.039 94 156.53 94 156",
    fill: "white"
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    d: "M94 162H90V166H94V162Z",
    fill: "white"
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    d: "M94 170V166H90V168C90 168.53 90.2107 169.039 90.5858 169.414C90.9609 169.789 91.4696 170 92 170",
    fill: "white"
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    d: "M94 34V38H98V36C98 35.4696 97.7893 34.9609 97.4142 34.5858C97.0391 34.2107 96.5304 34 96 34",
    fill: "white"
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    d: "M98 42V38H94V40C94 40.5304 94.2107 41.0391 94.5858 41.4142C94.9609 41.7893 95.4696 42 96 42",
    fill: "white"
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    d: "M94 46V50H96C96.5304 50 97.0391 49.7893 97.4142 49.4142C97.7893 49.0391 98 48.5304 98 48C98 47.4696 97.7893 46.9609 97.4142 46.5858C97.0391 46.2107 96.5304 46 96 46",
    fill: "white"
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    d: "M98 54H94V58H98V54Z",
    fill: "white"
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    d: "M98 70V66H96C95.4696 66 94.9609 66.2107 94.5858 66.5858C94.2107 66.9609 94 67.4696 94 68C94 68.5304 94.2107 69.0391 94.5858 69.4142C94.9609 69.7893 95.4696 70 96 70",
    fill: "white"
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    d: "M98 126H94V130H98V126Z",
    fill: "white"
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    d: "M98 130H94V134H98V130Z",
    fill: "white"
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    d: "M96 150C97.1046 150 98 149.105 98 148C98 146.895 97.1046 146 96 146C94.8954 146 94 146.895 94 148C94 149.105 94.8954 150 96 150Z",
    fill: "white"
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    d: "M94 162V166H98V164C98 163.47 97.7893 162.961 97.4142 162.586C97.0391 162.211 96.5304 162 96 162",
    fill: "white"
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    d: "M98 166H94V170H96C96.5304 170 97.0391 169.789 97.4142 169.414C97.7893 169.039 98 168.53 98 168",
    fill: "white"
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    d: "M94 178H98V176C98 175.47 97.7893 174.961 97.4142 174.586C97.0391 174.211 96.5304 174 96 174C95.4696 174 94.9609 174.211 94.5858 174.586C94.2107 174.961 94 175.47 94 176",
    fill: "white"
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    d: "M98 182V178H94V180C94 180.53 94.2107 181.039 94.5858 181.414C94.9609 181.789 95.4696 182 96 182",
    fill: "white"
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    d: "M98 22H102V20C102 19.4696 101.789 18.9609 101.414 18.5858C101.039 18.2107 100.53 18 100 18C99.4696 18 98.9609 18.2107 98.5858 18.5858C98.2107 18.9609 98 19.4696 98 20",
    fill: "white"
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    d: "M102 22H98V24C98 24.5304 98.2107 25.0391 98.5858 25.4142C98.9609 25.7893 99.4696 26 100 26C100.53 26 101.039 25.7893 101.414 25.4142C101.789 25.0391 102 24.5304 102 24",
    fill: "white"
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    d: "M102 38H98V42H102V38Z",
    fill: "white"
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    d: "M102 42H98V44C98 44.5304 98.2107 45.0391 98.5858 45.4142C98.9609 45.7893 99.4696 46 100 46C100.53 46 101.039 45.7893 101.414 45.4142C101.789 45.0391 102 44.5304 102 44",
    fill: "white"
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    d: "M98 54H102V52C102 51.4696 101.789 50.9609 101.414 50.5858C101.039 50.2107 100.53 50 100 50C99.4696 50 98.9609 50.2107 98.5858 50.5858C98.2107 50.9609 98 51.4696 98 52",
    fill: "white"
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    d: "M102 54H98V58H102V54Z",
    fill: "white"
  })), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    d: "M102 58H98V62H102V58Z",
    fill: "white"
  })), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    d: "M102 62H98V66H102V62Z",
    fill: "white"
  })), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    d: "M102 66H98V70H102V66Z",
    fill: "white"
  })), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    d: "M102 78V74H100C99.4696 74 98.9609 74.2107 98.5858 74.5858C98.2107 74.9609 98 75.4696 98 76C98 76.5304 98.2107 77.0391 98.5858 77.4142C98.9609 77.7893 99.4696 78 100 78",
    fill: "white"
  })), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    d: "M98 126V130H102V128C102 127.47 101.789 126.961 101.414 126.586C101.039 126.211 100.53 126 100 126",
    fill: "white"
  })), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    d: "M102 130H98V134H102V130Z",
    fill: "white"
  })), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    d: "M102 134H98V138H102V134Z",
    fill: "white"
  })), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    d: "M102 138H98V140C98 140.53 98.2107 141.039 98.5858 141.414C98.9609 141.789 99.4696 142 100 142C100.53 142 101.039 141.789 101.414 141.414C101.789 141.039 102 140.53 102 140",
    fill: "white"
  })), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    d: "M102 174V170H100C99.4696 170 98.9609 170.211 98.5858 170.586C98.2107 170.961 98 171.47 98 172C98 172.53 98.2107 173.039 98.5858 173.414C98.9609 173.789 99.4696 174 100 174",
    fill: "white"
  })), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    d: "M102 178H98V182H102V178Z",
    fill: "white"
  })), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    d: "M102 30H106V28C106 27.4696 105.789 26.9609 105.414 26.5858C105.039 26.2107 104.53 26 104 26C103.47 26 102.961 26.2107 102.586 26.5858C102.211 26.9609 102 27.4696 102 28",
    fill: "white"
  })), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    d: "M106 34V30H102V32C102 32.5304 102.211 33.0391 102.586 33.4142C102.961 33.7893 103.47 34 104 34",
    fill: "white"
  })), _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    d: "M102 38V42H104C104.53 42 105.039 41.7893 105.414 41.4142C105.789 41.0391 106 40.5304 106 40C106 39.4696 105.789 38.9609 105.414 38.5858C105.039 38.2107 104.53 38 104 38",
    fill: "white"
  })), _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    d: "M106 50V46H104C103.47 46 102.961 46.2107 102.586 46.5858C102.211 46.9609 102 47.4696 102 48C102 48.5304 102.211 49.0391 102.586 49.4142C102.961 49.7893 103.47 50 104 50",
    fill: "white"
  })), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    d: "M106 58H102V62H106V58Z",
    fill: "white"
  })), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    d: "M102 66V70H104C104.53 70 105.039 69.7893 105.414 69.4142C105.789 69.0391 106 68.5304 106 68C106 67.4696 105.789 66.9609 105.414 66.5858C105.039 66.2107 104.53 66 104 66",
    fill: "white"
  })), _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    d: "M102 74V78H104C104.53 78 105.039 77.7893 105.414 77.4142C105.789 77.0391 106 76.5304 106 76C106 75.4696 105.789 74.9609 105.414 74.5858C105.039 74.2107 104.53 74 104 74",
    fill: "white"
  })), _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    d: "M104 126C105.105 126 106 125.105 106 124C106 122.895 105.105 122 104 122C102.895 122 102 122.895 102 124C102 125.105 102.895 126 104 126Z",
    fill: "white"
  })), _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    d: "M102 130V134H104C104.53 134 105.039 133.789 105.414 133.414C105.789 133.039 106 132.53 106 132C106 131.47 105.789 130.961 105.414 130.586C105.039 130.211 104.53 130 104 130",
    fill: "white"
  })), _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    d: "M102 146H106V144C106 143.47 105.789 142.961 105.414 142.586C105.039 142.211 104.53 142 104 142C103.47 142 102.961 142.211 102.586 142.586C102.211 142.961 102 143.47 102 144",
    fill: "white"
  })), _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    d: "M106 146H102V150H106V146Z",
    fill: "white"
  })), _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    d: "M106 150H102V154H106V150Z",
    fill: "white"
  })), _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
    d: "M106 154H102V156C102 156.53 102.211 157.039 102.586 157.414C102.961 157.789 103.47 158 104 158C104.53 158 105.039 157.789 105.414 157.414C105.789 157.039 106 156.53 106 156",
    fill: "white"
  })), _path320 || (_path320 = /*#__PURE__*/React.createElement("path", {
    d: "M104 166C105.105 166 106 165.105 106 164C106 162.895 105.105 162 104 162C102.895 162 102 162.895 102 164C102 165.105 102.895 166 104 166Z",
    fill: "white"
  })), _path321 || (_path321 = /*#__PURE__*/React.createElement("path", {
    d: "M102 170V174H106V172C106 171.47 105.789 170.961 105.414 170.586C105.039 170.211 104.53 170 104 170",
    fill: "white"
  })), _path322 || (_path322 = /*#__PURE__*/React.createElement("path", {
    d: "M106 174H102V178H106V174Z",
    fill: "white"
  })), _path323 || (_path323 = /*#__PURE__*/React.createElement("path", {
    d: "M106 178H102V182H104C104.53 182 105.039 181.789 105.414 181.414C105.789 181.039 106 180.53 106 180",
    fill: "white"
  })), _path324 || (_path324 = /*#__PURE__*/React.createElement("path", {
    d: "M108 22C109.105 22 110 21.1046 110 20C110 18.8954 109.105 18 108 18C106.895 18 106 18.8954 106 20C106 21.1046 106.895 22 108 22Z",
    fill: "white"
  })), _path325 || (_path325 = /*#__PURE__*/React.createElement("path", {
    d: "M106 30V34H110V32C110 31.4696 109.789 30.9609 109.414 30.5858C109.039 30.2107 108.53 30 108 30",
    fill: "white"
  })), _path326 || (_path326 = /*#__PURE__*/React.createElement("path", {
    d: "M110 34H106V36C106 36.5304 106.211 37.0391 106.586 37.4142C106.961 37.7893 107.47 38 108 38C108.53 38 109.039 37.7893 109.414 37.4142C109.789 37.0391 110 36.5304 110 36",
    fill: "white"
  })), _path327 || (_path327 = /*#__PURE__*/React.createElement("path", {
    d: "M106 46H110V44C110 43.4696 109.789 42.9609 109.414 42.5858C109.039 42.2107 108.53 42 108 42C107.47 42 106.961 42.2107 106.586 42.5858C106.211 42.9609 106 43.4696 106 44",
    fill: "white"
  })), _path328 || (_path328 = /*#__PURE__*/React.createElement("path", {
    d: "M110 46H106V50H108C108.53 50 109.039 49.7893 109.414 49.4142C109.789 49.0391 110 48.5304 110 48",
    fill: "white"
  })), _path329 || (_path329 = /*#__PURE__*/React.createElement("path", {
    d: "M106 58V62H110V60C110 59.4696 109.789 58.9609 109.414 58.5858C109.039 58.2107 108.53 58 108 58",
    fill: "white"
  })), _path330 || (_path330 = /*#__PURE__*/React.createElement("path", {
    d: "M110 66V62H106V64C106 64.5304 106.211 65.0391 106.586 65.4142C106.961 65.7893 107.47 66 108 66",
    fill: "white"
  })), _path331 || (_path331 = /*#__PURE__*/React.createElement("path", {
    d: "M110 130V126H108C107.47 126 106.961 126.211 106.586 126.586C106.211 126.961 106 127.47 106 128C106 128.53 106.211 129.039 106.586 129.414C106.961 129.789 107.47 130 108 130",
    fill: "white"
  })), _path332 || (_path332 = /*#__PURE__*/React.createElement("path", {
    d: "M110 142V138H108C107.47 138 106.961 138.211 106.586 138.586C106.211 138.961 106 139.47 106 140C106 140.53 106.211 141.039 106.586 141.414C106.961 141.789 107.47 142 108 142",
    fill: "white"
  })), _path333 || (_path333 = /*#__PURE__*/React.createElement("path", {
    d: "M110 146H106V150H110V146Z",
    fill: "white"
  })), _path334 || (_path334 = /*#__PURE__*/React.createElement("path", {
    d: "M110 150H106V154H108C108.53 154 109.039 153.789 109.414 153.414C109.789 153.039 110 152.53 110 152",
    fill: "white"
  })), _path335 || (_path335 = /*#__PURE__*/React.createElement("path", {
    d: "M110 162V158H108C107.47 158 106.961 158.211 106.586 158.586C106.211 158.961 106 159.47 106 160C106 160.53 106.211 161.039 106.586 161.414C106.961 161.789 107.47 162 108 162",
    fill: "white"
  })), _path336 || (_path336 = /*#__PURE__*/React.createElement("path", {
    d: "M110 170V166H108C107.47 166 106.961 166.211 106.586 166.586C106.211 166.961 106 167.47 106 168C106 168.53 106.211 169.039 106.586 169.414C106.961 169.789 107.47 170 108 170",
    fill: "white"
  })), _path337 || (_path337 = /*#__PURE__*/React.createElement("path", {
    d: "M110 54H114V52C114 51.4696 113.789 50.9609 113.414 50.5858C113.039 50.2107 112.53 50 112 50C111.47 50 110.961 50.2107 110.586 50.5858C110.211 50.9609 110 51.4696 110 52",
    fill: "white"
  })), _path338 || (_path338 = /*#__PURE__*/React.createElement("path", {
    d: "M114 54H110V56C110 56.5304 110.211 57.0391 110.586 57.4142C110.961 57.7893 111.47 58 112 58C112.53 58 113.039 57.7893 113.414 57.4142C113.789 57.0391 114 56.5304 114 56",
    fill: "white"
  })), _path339 || (_path339 = /*#__PURE__*/React.createElement("path", {
    d: "M114 62H110V66H114V62Z",
    fill: "white"
  })), _path340 || (_path340 = /*#__PURE__*/React.createElement("path", {
    d: "M114 74V70H112C111.47 70 110.961 70.2107 110.586 70.5858C110.211 70.9609 110 71.4696 110 72C110 72.5304 110.211 73.0391 110.586 73.4142C110.961 73.7893 111.47 74 112 74",
    fill: "white"
  })), _path341 || (_path341 = /*#__PURE__*/React.createElement("path", {
    d: "M114 126H110V130H114V126Z",
    fill: "white"
  })), _path342 || (_path342 = /*#__PURE__*/React.createElement("path", {
    d: "M114 130H110V132C110 132.53 110.211 133.039 110.586 133.414C110.961 133.789 111.47 134 112 134C112.53 134 113.039 133.789 113.414 133.414C113.789 133.039 114 132.53 114 132",
    fill: "white"
  })), _path343 || (_path343 = /*#__PURE__*/React.createElement("path", {
    d: "M110 138V142H114V140C114 139.47 113.789 138.961 113.414 138.586C113.039 138.211 112.53 138 112 138",
    fill: "white"
  })), _path344 || (_path344 = /*#__PURE__*/React.createElement("path", {
    d: "M114 142H110V146H114V142Z",
    fill: "white"
  })), _path345 || (_path345 = /*#__PURE__*/React.createElement("path", {
    d: "M114 146H110V150H112C112.53 150 113.039 149.789 113.414 149.414C113.789 149.039 114 148.53 114 148",
    fill: "white"
  })), _path346 || (_path346 = /*#__PURE__*/React.createElement("path", {
    d: "M110 158V162H114V160C114 159.47 113.789 158.961 113.414 158.586C113.039 158.211 112.53 158 112 158",
    fill: "white"
  })), _path347 || (_path347 = /*#__PURE__*/React.createElement("path", {
    d: "M114 162H110V166H114V162Z",
    fill: "white"
  })), _path348 || (_path348 = /*#__PURE__*/React.createElement("path", {
    d: "M114 166H110V170H112C112.53 170 113.039 169.789 113.414 169.414C113.789 169.039 114 168.53 114 168",
    fill: "white"
  })), _path349 || (_path349 = /*#__PURE__*/React.createElement("path", {
    d: "M114 30H118V28C118 27.4696 117.789 26.9609 117.414 26.5858C117.039 26.2107 116.53 26 116 26C115.47 26 114.961 26.2107 114.586 26.5858C114.211 26.9609 114 27.4696 114 28",
    fill: "white"
  })), _path350 || (_path350 = /*#__PURE__*/React.createElement("path", {
    d: "M118 30H114V32C114 32.5304 114.211 33.0391 114.586 33.4142C114.961 33.7893 115.47 34 116 34C116.53 34 117.039 33.7893 117.414 33.4142C117.789 33.0391 118 32.5304 118 32",
    fill: "white"
  })), _path351 || (_path351 = /*#__PURE__*/React.createElement("path", {
    d: "M114 46H118V44C118 43.4696 117.789 42.9609 117.414 42.5858C117.039 42.2107 116.53 42 116 42C115.47 42 114.961 42.2107 114.586 42.5858C114.211 42.9609 114 43.4696 114 44",
    fill: "white"
  })), _path352 || (_path352 = /*#__PURE__*/React.createElement("path", {
    d: "M118 46H114V48C114 48.5304 114.211 49.0391 114.586 49.4142C114.961 49.7893 115.47 50 116 50C116.53 50 117.039 49.7893 117.414 49.4142C117.789 49.0391 118 48.5304 118 48",
    fill: "white"
  })), _path353 || (_path353 = /*#__PURE__*/React.createElement("path", {
    d: "M114 62H118V58H116C115.47 58 114.961 58.2107 114.586 58.5858C114.211 58.9609 114 59.4696 114 60",
    fill: "white"
  })), _path354 || (_path354 = /*#__PURE__*/React.createElement("path", {
    d: "M118 62H114V66H118V62Z",
    fill: "white"
  })), _path355 || (_path355 = /*#__PURE__*/React.createElement("path", {
    d: "M118 66H114V70H118V66Z",
    fill: "white"
  })), _path356 || (_path356 = /*#__PURE__*/React.createElement("path", {
    d: "M118 70H114V74H118V70Z",
    fill: "white"
  })), _path357 || (_path357 = /*#__PURE__*/React.createElement("path", {
    d: "M114 126H118V122H116C115.47 122 114.961 122.211 114.586 122.586C114.211 122.961 114 123.47 114 124",
    fill: "white"
  })), _path358 || (_path358 = /*#__PURE__*/React.createElement("path", {
    d: "M118 126H114V130H116C116.53 130 117.039 129.789 117.414 129.414C117.789 129.039 118 128.53 118 128",
    fill: "white"
  })), _path359 || (_path359 = /*#__PURE__*/React.createElement("path", {
    d: "M116 138C117.105 138 118 137.105 118 136C118 134.895 117.105 134 116 134C114.895 134 114 134.895 114 136C114 137.105 114.895 138 116 138Z",
    fill: "white"
  })), _path360 || (_path360 = /*#__PURE__*/React.createElement("path", {
    d: "M118 142H114V146H118V142Z",
    fill: "white"
  })), _path361 || (_path361 = /*#__PURE__*/React.createElement("path", {
    d: "M114 174H118V172C118 171.47 117.789 170.961 117.414 170.586C117.039 170.211 116.53 170 116 170C115.47 170 114.961 170.211 114.586 170.586C114.211 170.961 114 171.47 114 172",
    fill: "white"
  })), _path362 || (_path362 = /*#__PURE__*/React.createElement("path", {
    d: "M118 174H114V178H118V174Z",
    fill: "white"
  })), _path363 || (_path363 = /*#__PURE__*/React.createElement("path", {
    d: "M118 182V178H114V180C114 180.53 114.211 181.039 114.586 181.414C114.961 181.789 115.47 182 116 182",
    fill: "white"
  })), _path364 || (_path364 = /*#__PURE__*/React.createElement("path", {
    d: "M120 38C121.105 38 122 37.1046 122 36C122 34.8954 121.105 34 120 34C118.895 34 118 34.8954 118 36C118 37.1046 118.895 38 120 38Z",
    fill: "white"
  })), _path365 || (_path365 = /*#__PURE__*/React.createElement("path", {
    d: "M118 58H122V56C122 55.4696 121.789 54.9609 121.414 54.5858C121.039 54.2107 120.53 54 120 54C119.47 54 118.961 54.2107 118.586 54.5858C118.211 54.9609 118 55.4696 118 56",
    fill: "white"
  })), _path366 || (_path366 = /*#__PURE__*/React.createElement("path", {
    d: "M122 58H118V62H122V58Z",
    fill: "white"
  })), _path367 || (_path367 = /*#__PURE__*/React.createElement("path", {
    d: "M122 62H118V66H122V62Z",
    fill: "white"
  })), _path368 || (_path368 = /*#__PURE__*/React.createElement("path", {
    d: "M122 70H118V74H122V70Z",
    fill: "white"
  })), _path369 || (_path369 = /*#__PURE__*/React.createElement("path", {
    d: "M118 122V126H120C120.53 126 121.039 125.789 121.414 125.414C121.789 125.039 122 124.53 122 124C122 123.47 121.789 122.961 121.414 122.586C121.039 122.211 120.53 122 120 122",
    fill: "white"
  })), _path370 || (_path370 = /*#__PURE__*/React.createElement("path", {
    d: "M118 142V146H120C120.53 146 121.039 145.789 121.414 145.414C121.789 145.039 122 144.53 122 144C122 143.47 121.789 142.961 121.414 142.586C121.039 142.211 120.53 142 120 142",
    fill: "white"
  })), _path371 || (_path371 = /*#__PURE__*/React.createElement("path", {
    d: "M118 154H122V150H120C119.47 150 118.961 150.211 118.586 150.586C118.211 150.961 118 151.47 118 152",
    fill: "white"
  })), _path372 || (_path372 = /*#__PURE__*/React.createElement("path", {
    d: "M122 158V154H118V156C118 156.53 118.211 157.039 118.586 157.414C118.961 157.789 119.47 158 120 158",
    fill: "white"
  })), _path373 || (_path373 = /*#__PURE__*/React.createElement("path", {
    d: "M118 166H122V162H120C119.47 162 118.961 162.211 118.586 162.586C118.211 162.961 118 163.47 118 164",
    fill: "white"
  })), _path374 || (_path374 = /*#__PURE__*/React.createElement("path", {
    d: "M122 166H118V168C118 168.53 118.211 169.039 118.586 169.414C118.961 169.789 119.47 170 120 170C120.53 170 121.039 169.789 121.414 169.414C121.789 169.039 122 168.53 122 168",
    fill: "white"
  })), _path375 || (_path375 = /*#__PURE__*/React.createElement("path", {
    d: "M118 174V178H122V176C122 175.47 121.789 174.961 121.414 174.586C121.039 174.211 120.53 174 120 174",
    fill: "white"
  })), _path376 || (_path376 = /*#__PURE__*/React.createElement("path", {
    d: "M122 178H118V182H120C120.53 182 121.039 181.789 121.414 181.414C121.789 181.039 122 180.53 122 180",
    fill: "white"
  })), _path377 || (_path377 = /*#__PURE__*/React.createElement("path", {
    d: "M122 22H126V20C126 19.4696 125.789 18.9609 125.414 18.5858C125.039 18.2107 124.53 18 124 18C123.47 18 122.961 18.2107 122.586 18.5858C122.211 18.9609 122 19.4696 122 20",
    fill: "white"
  })), _path378 || (_path378 = /*#__PURE__*/React.createElement("path", {
    d: "M126 22H122V26H126V22Z",
    fill: "white"
  })), _path379 || (_path379 = /*#__PURE__*/React.createElement("path", {
    d: "M126 26H122V30H126V26Z",
    fill: "white"
  })), _path380 || (_path380 = /*#__PURE__*/React.createElement("path", {
    d: "M126 34V30H122V32C122 32.5304 122.211 33.0391 122.586 33.4142C122.961 33.7893 123.47 34 124 34",
    fill: "white"
  })), _path381 || (_path381 = /*#__PURE__*/React.createElement("path", {
    d: "M124 46C125.105 46 126 45.1046 126 44C126 42.8954 125.105 42 124 42C122.895 42 122 42.8954 122 44C122 45.1046 122.895 46 124 46Z",
    fill: "white"
  })), _path382 || (_path382 = /*#__PURE__*/React.createElement("path", {
    d: "M124 54C125.105 54 126 53.1046 126 52C126 50.8954 125.105 50 124 50C122.895 50 122 50.8954 122 52C122 53.1046 122.895 54 124 54Z",
    fill: "white"
  })), _path383 || (_path383 = /*#__PURE__*/React.createElement("path", {
    d: "M126 58H122V62H126V58Z",
    fill: "white"
  })), _path384 || (_path384 = /*#__PURE__*/React.createElement("path", {
    d: "M126 62H122V66H124C124.53 66 125.039 65.7893 125.414 65.4142C125.789 65.0391 126 64.5304 126 64",
    fill: "white"
  })), _path385 || (_path385 = /*#__PURE__*/React.createElement("path", {
    d: "M126 70H122V74H126V70Z",
    fill: "white"
  })), _path386 || (_path386 = /*#__PURE__*/React.createElement("path", {
    d: "M122 130H126V128C126 127.47 125.789 126.961 125.414 126.586C125.039 126.211 124.53 126 124 126C123.47 126 122.961 126.211 122.586 126.586C122.211 126.961 122 127.47 122 128",
    fill: "white"
  })), _path387 || (_path387 = /*#__PURE__*/React.createElement("path", {
    d: "M126 130H122V132C122 132.53 122.211 133.039 122.586 133.414C122.961 133.789 123.47 134 124 134C124.53 134 125.039 133.789 125.414 133.414C125.789 133.039 126 132.53 126 132",
    fill: "white"
  })), _path388 || (_path388 = /*#__PURE__*/React.createElement("path", {
    d: "M126 142V138H124C123.47 138 122.961 138.211 122.586 138.586C122.211 138.961 122 139.47 122 140C122 140.53 122.211 141.039 122.586 141.414C122.961 141.789 123.47 142 124 142",
    fill: "white"
  })), _path389 || (_path389 = /*#__PURE__*/React.createElement("path", {
    d: "M122 150H126V146H124C123.47 146 122.961 146.211 122.586 146.586C122.211 146.961 122 147.47 122 148",
    fill: "white"
  })), _path390 || (_path390 = /*#__PURE__*/React.createElement("path", {
    d: "M126 150H122V154H126V150Z",
    fill: "white"
  })), _path391 || (_path391 = /*#__PURE__*/React.createElement("path", {
    d: "M126 154H122V158H124C124.53 158 125.039 157.789 125.414 157.414C125.789 157.039 126 156.53 126 156",
    fill: "white"
  })), _path392 || (_path392 = /*#__PURE__*/React.createElement("path", {
    d: "M122 162V166H124C124.53 166 125.039 165.789 125.414 165.414C125.789 165.039 126 164.53 126 164C126 163.47 125.789 162.961 125.414 162.586C125.039 162.211 124.53 162 124 162",
    fill: "white"
  })), _path393 || (_path393 = /*#__PURE__*/React.createElement("path", {
    d: "M126 22V26H128C128.53 26 129.039 25.7893 129.414 25.4142C129.789 25.0391 130 24.5304 130 24C130 23.4696 129.789 22.9609 129.414 22.5858C129.039 22.2107 128.53 22 128 22",
    fill: "white"
  })), _path394 || (_path394 = /*#__PURE__*/React.createElement("path", {
    d: "M130 30H126V34H130V30Z",
    fill: "white"
  })), _path395 || (_path395 = /*#__PURE__*/React.createElement("path", {
    d: "M130 34H126V36C126 36.5304 126.211 37.0391 126.586 37.4142C126.961 37.7893 127.47 38 128 38C128.53 38 129.039 37.7893 129.414 37.4142C129.789 37.0391 130 36.5304 130 36",
    fill: "white"
  })), _path396 || (_path396 = /*#__PURE__*/React.createElement("path", {
    d: "M126 58V62H128C128.53 62 129.039 61.7893 129.414 61.4142C129.789 61.0391 130 60.5304 130 60C130 59.4696 129.789 58.9609 129.414 58.5858C129.039 58.2107 128.53 58 128 58",
    fill: "white"
  })), _path397 || (_path397 = /*#__PURE__*/React.createElement("path", {
    d: "M126 70V74H130V72C130 71.4696 129.789 70.9609 129.414 70.5858C129.039 70.2107 128.53 70 128 70",
    fill: "white"
  })), _path398 || (_path398 = /*#__PURE__*/React.createElement("path", {
    d: "M130 74H126V76C126 76.5304 126.211 77.0391 126.586 77.4142C126.961 77.7893 127.47 78 128 78C128.53 78 129.039 77.7893 129.414 77.4142C129.789 77.0391 130 76.5304 130 76",
    fill: "white"
  })), _path399 || (_path399 = /*#__PURE__*/React.createElement("path", {
    d: "M128 94C129.105 94 130 93.1046 130 92C130 90.8954 129.105 90 128 90C126.895 90 126 90.8954 126 92C126 93.1046 126.895 94 128 94Z",
    fill: "white"
  })), _path400 || (_path400 = /*#__PURE__*/React.createElement("path", {
    d: "M126 106H130V102H128C127.47 102 126.961 102.211 126.586 102.586C126.211 102.961 126 103.47 126 104",
    fill: "white"
  })), _path401 || (_path401 = /*#__PURE__*/React.createElement("path", {
    d: "M130 106H126V108C126 108.53 126.211 109.039 126.586 109.414C126.961 109.789 127.47 110 128 110C128.53 110 129.039 109.789 129.414 109.414C129.789 109.039 130 108.53 130 108",
    fill: "white"
  })), _path402 || (_path402 = /*#__PURE__*/React.createElement("path", {
    d: "M130 126V122H128C127.47 122 126.961 122.211 126.586 122.586C126.211 122.961 126 123.47 126 124C126 124.53 126.211 125.039 126.586 125.414C126.961 125.789 127.47 126 128 126",
    fill: "white"
  })), _path403 || (_path403 = /*#__PURE__*/React.createElement("path", {
    d: "M130 138H126V142H130V138Z",
    fill: "white"
  })), _path404 || (_path404 = /*#__PURE__*/React.createElement("path", {
    d: "M130 142H126V146H130V142Z",
    fill: "white"
  })), _path405 || (_path405 = /*#__PURE__*/React.createElement("path", {
    d: "M130 146H126V150H130V146Z",
    fill: "white"
  })), _path406 || (_path406 = /*#__PURE__*/React.createElement("path", {
    d: "M128 162C129.105 162 130 161.105 130 160C130 158.895 129.105 158 128 158C126.895 158 126 158.895 126 160C126 161.105 126.895 162 128 162Z",
    fill: "white"
  })), _path407 || (_path407 = /*#__PURE__*/React.createElement("path", {
    d: "M130 170V166H128C127.47 166 126.961 166.211 126.586 166.586C126.211 166.961 126 167.47 126 168C126 168.53 126.211 169.039 126.586 169.414C126.961 169.789 127.47 170 128 170",
    fill: "white"
  })), _path408 || (_path408 = /*#__PURE__*/React.createElement("path", {
    d: "M130 30V34H132C132.53 34 133.039 33.7893 133.414 33.4142C133.789 33.0391 134 32.5304 134 32C134 31.4696 133.789 30.9609 133.414 30.5858C133.039 30.2107 132.53 30 132 30",
    fill: "white"
  })), _path409 || (_path409 = /*#__PURE__*/React.createElement("path", {
    d: "M132 46C133.105 46 134 45.1046 134 44C134 42.8954 133.105 42 132 42C130.895 42 130 42.8954 130 44C130 45.1046 130.895 46 132 46Z",
    fill: "white"
  })), _path410 || (_path410 = /*#__PURE__*/React.createElement("path", {
    d: "M134 54V50H132C131.47 50 130.961 50.2107 130.586 50.5858C130.211 50.9609 130 51.4696 130 52C130 52.5304 130.211 53.0391 130.586 53.4142C130.961 53.7893 131.47 54 132 54",
    fill: "white"
  })), _path411 || (_path411 = /*#__PURE__*/React.createElement("path", {
    d: "M132 90C133.105 90 134 89.1046 134 88C134 86.8954 133.105 86 132 86C130.895 86 130 86.8954 130 88C130 89.1046 130.895 90 132 90Z",
    fill: "white"
  })), _path412 || (_path412 = /*#__PURE__*/React.createElement("path", {
    d: "M134 102H130V106H134V102Z",
    fill: "white"
  })), _path413 || (_path413 = /*#__PURE__*/React.createElement("path", {
    d: "M130 114H134V112C134 111.47 133.789 110.961 133.414 110.586C133.039 110.211 132.53 110 132 110C131.47 110 130.961 110.211 130.586 110.586C130.211 110.961 130 111.47 130 112",
    fill: "white"
  })), _path414 || (_path414 = /*#__PURE__*/React.createElement("path", {
    d: "M134 114H130V118H134V114Z",
    fill: "white"
  })), _path415 || (_path415 = /*#__PURE__*/React.createElement("path", {
    d: "M134 118H130V122H134V118Z",
    fill: "white"
  })), _path416 || (_path416 = /*#__PURE__*/React.createElement("path", {
    d: "M134 122H130V126H134V122Z",
    fill: "white"
  })), _path417 || (_path417 = /*#__PURE__*/React.createElement("path", {
    d: "M134 126H130V130H134V126Z",
    fill: "white"
  })), _path418 || (_path418 = /*#__PURE__*/React.createElement("path", {
    d: "M134 130H130V134H134V130Z",
    fill: "white"
  })), _path419 || (_path419 = /*#__PURE__*/React.createElement("path", {
    d: "M134 134H130V138H134V134Z",
    fill: "white"
  })), _path420 || (_path420 = /*#__PURE__*/React.createElement("path", {
    d: "M134 138H130V142H134V138Z",
    fill: "white"
  })), _path421 || (_path421 = /*#__PURE__*/React.createElement("path", {
    d: "M134 142H130V146H134V142Z",
    fill: "white"
  })), _path422 || (_path422 = /*#__PURE__*/React.createElement("path", {
    d: "M134 146H130V150H132C132.53 150 133.039 149.789 133.414 149.414C133.789 149.039 134 148.53 134 148",
    fill: "white"
  })), _path423 || (_path423 = /*#__PURE__*/React.createElement("path", {
    d: "M134 166H130V170H134V166Z",
    fill: "white"
  })), _path424 || (_path424 = /*#__PURE__*/React.createElement("path", {
    d: "M134 170H130V174H134V170Z",
    fill: "white"
  })), _path425 || (_path425 = /*#__PURE__*/React.createElement("path", {
    d: "M134 178V174H130V176C130 176.53 130.211 177.039 130.586 177.414C130.961 177.789 131.47 178 132 178",
    fill: "white"
  })), _path426 || (_path426 = /*#__PURE__*/React.createElement("path", {
    d: "M138 22V18H136C135.47 18 134.961 18.2107 134.586 18.5858C134.211 18.9609 134 19.4696 134 20C134 20.5304 134.211 21.0391 134.586 21.4142C134.961 21.7893 135.47 22 136 22",
    fill: "white"
  })), _path427 || (_path427 = /*#__PURE__*/React.createElement("path", {
    d: "M136 42C137.105 42 138 41.1046 138 40C138 38.8954 137.105 38 136 38C134.895 38 134 38.8954 134 40C134 41.1046 134.895 42 136 42Z",
    fill: "white"
  })), _path428 || (_path428 = /*#__PURE__*/React.createElement("path", {
    d: "M138 50H134V54H138V50Z",
    fill: "white"
  })), _path429 || (_path429 = /*#__PURE__*/React.createElement("path", {
    d: "M134 66H138V64C138 63.4696 137.789 62.9609 137.414 62.5858C137.039 62.2107 136.53 62 136 62C135.47 62 134.961 62.2107 134.586 62.5858C134.211 62.9609 134 63.4696 134 64",
    fill: "white"
  })), _path430 || (_path430 = /*#__PURE__*/React.createElement("path", {
    d: "M138 66H134V70H138V66Z",
    fill: "white"
  })), _path431 || (_path431 = /*#__PURE__*/React.createElement("path", {
    d: "M138 70H134V74H138V70Z",
    fill: "white"
  })), _path432 || (_path432 = /*#__PURE__*/React.createElement("path", {
    d: "M138 74H134V78H138V74Z",
    fill: "white"
  })), _path433 || (_path433 = /*#__PURE__*/React.createElement("path", {
    d: "M138 78H134V82H138V78Z",
    fill: "white"
  })), _path434 || (_path434 = /*#__PURE__*/React.createElement("path", {
    d: "M138 86V82H134V84C134 84.5304 134.211 85.0391 134.586 85.4142C134.961 85.7893 135.47 86 136 86",
    fill: "white"
  })), _path435 || (_path435 = /*#__PURE__*/React.createElement("path", {
    d: "M134 94H138V92C138 91.4696 137.789 90.9609 137.414 90.5858C137.039 90.2107 136.53 90 136 90C135.47 90 134.961 90.2107 134.586 90.5858C134.211 90.9609 134 91.4696 134 92",
    fill: "white"
  })), _path436 || (_path436 = /*#__PURE__*/React.createElement("path", {
    d: "M138 94H134V98H138V94Z",
    fill: "white"
  })), _path437 || (_path437 = /*#__PURE__*/React.createElement("path", {
    d: "M138 98H134V102H138V98Z",
    fill: "white"
  })), _path438 || (_path438 = /*#__PURE__*/React.createElement("path", {
    d: "M138 102H134V106H138V102Z",
    fill: "white"
  })), _path439 || (_path439 = /*#__PURE__*/React.createElement("path", {
    d: "M138 106H134V108C134 108.53 134.211 109.039 134.586 109.414C134.961 109.789 135.47 110 136 110C136.53 110 137.039 109.789 137.414 109.414C137.789 109.039 138 108.53 138 108",
    fill: "white"
  })), _path440 || (_path440 = /*#__PURE__*/React.createElement("path", {
    d: "M138 114H134V118H138V114Z",
    fill: "white"
  })), _path441 || (_path441 = /*#__PURE__*/React.createElement("path", {
    d: "M134 134V138H138V136C138 135.47 137.789 134.961 137.414 134.586C137.039 134.211 136.53 134 136 134",
    fill: "white"
  })), _path442 || (_path442 = /*#__PURE__*/React.createElement("path", {
    d: "M138 138H134V142H138V138Z",
    fill: "white"
  })), _path443 || (_path443 = /*#__PURE__*/React.createElement("path", {
    d: "M138 142H134V146H136C136.53 146 137.039 145.789 137.414 145.414C137.789 145.039 138 144.53 138 144",
    fill: "white"
  })), _path444 || (_path444 = /*#__PURE__*/React.createElement("path", {
    d: "M134 154H138V150H136C135.47 150 134.961 150.211 134.586 150.586C134.211 150.961 134 151.47 134 152",
    fill: "white"
  })), _path445 || (_path445 = /*#__PURE__*/React.createElement("path", {
    d: "M138 158V154H134V156C134 156.53 134.211 157.039 134.586 157.414C134.961 157.789 135.47 158 136 158",
    fill: "white"
  })), _path446 || (_path446 = /*#__PURE__*/React.createElement("path", {
    d: "M134 166H138V162H136C135.47 162 134.961 162.211 134.586 162.586C134.211 162.961 134 163.47 134 164",
    fill: "white"
  })), _path447 || (_path447 = /*#__PURE__*/React.createElement("path", {
    d: "M138 166H134V170H138V166Z",
    fill: "white"
  })), _path448 || (_path448 = /*#__PURE__*/React.createElement("path", {
    d: "M138 170H134V174H138V170Z",
    fill: "white"
  })), _path449 || (_path449 = /*#__PURE__*/React.createElement("path", {
    d: "M138 174H134V178H138V174Z",
    fill: "white"
  })), _path450 || (_path450 = /*#__PURE__*/React.createElement("path", {
    d: "M138 178H134V180C134 180.53 134.211 181.039 134.586 181.414C134.961 181.789 135.47 182 136 182C136.53 182 137.039 181.789 137.414 181.414C137.789 181.039 138 180.53 138 180",
    fill: "white"
  })), _path451 || (_path451 = /*#__PURE__*/React.createElement("path", {
    d: "M142 18H138V22H142V18Z",
    fill: "white"
  })), _path452 || (_path452 = /*#__PURE__*/React.createElement("path", {
    d: "M138 46H142V44C142 43.4696 141.789 42.9609 141.414 42.5858C141.039 42.2107 140.53 42 140 42C139.47 42 138.961 42.2107 138.586 42.5858C138.211 42.9609 138 43.4696 138 44",
    fill: "white"
  })), _path453 || (_path453 = /*#__PURE__*/React.createElement("path", {
    d: "M142 46H138V50H142V46Z",
    fill: "white"
  })), _path454 || (_path454 = /*#__PURE__*/React.createElement("path", {
    d: "M142 50H138V54H142V50Z",
    fill: "white"
  })), _path455 || (_path455 = /*#__PURE__*/React.createElement("path", {
    d: "M142 54H138V56C138 56.5304 138.211 57.0391 138.586 57.4142C138.961 57.7893 139.47 58 140 58C140.53 58 141.039 57.7893 141.414 57.4142C141.789 57.0391 142 56.5304 142 56",
    fill: "white"
  })), _path456 || (_path456 = /*#__PURE__*/React.createElement("path", {
    d: "M142 78H138V82H142V78Z",
    fill: "white"
  })), _path457 || (_path457 = /*#__PURE__*/React.createElement("path", {
    d: "M142 82H138V86H142V82Z",
    fill: "white"
  })), _path458 || (_path458 = /*#__PURE__*/React.createElement("path", {
    d: "M142 90V86H138V88C138 88.5304 138.211 89.0391 138.586 89.4142C138.961 89.7893 139.47 90 140 90",
    fill: "white"
  })), _path459 || (_path459 = /*#__PURE__*/React.createElement("path", {
    d: "M142 98H138V102H142V98Z",
    fill: "white"
  })), _path460 || (_path460 = /*#__PURE__*/React.createElement("path", {
    d: "M142 102H138V106H140C140.53 106 141.039 105.789 141.414 105.414C141.789 105.039 142 104.53 142 104",
    fill: "white"
  })), _path461 || (_path461 = /*#__PURE__*/React.createElement("path", {
    d: "M142 114H138V118H142V114Z",
    fill: "white"
  })), _path462 || (_path462 = /*#__PURE__*/React.createElement("path", {
    d: "M138 126H142V124C142 123.47 141.789 122.961 141.414 122.586C141.039 122.211 140.53 122 140 122C139.47 122 138.961 122.211 138.586 122.586C138.211 122.961 138 123.47 138 124",
    fill: "white"
  })), _path463 || (_path463 = /*#__PURE__*/React.createElement("path", {
    d: "M142 126H138V130H142V126Z",
    fill: "white"
  })), _path464 || (_path464 = /*#__PURE__*/React.createElement("path", {
    d: "M142 130H138V132C138 132.53 138.211 133.039 138.586 133.414C138.961 133.789 139.47 134 140 134C140.53 134 141.039 133.789 141.414 133.414C141.789 133.039 142 132.53 142 132",
    fill: "white"
  })), _path465 || (_path465 = /*#__PURE__*/React.createElement("path", {
    d: "M138 138V142H140C140.53 142 141.039 141.789 141.414 141.414C141.789 141.039 142 140.53 142 140C142 139.47 141.789 138.961 141.414 138.586C141.039 138.211 140.53 138 140 138",
    fill: "white"
  })), _path466 || (_path466 = /*#__PURE__*/React.createElement("path", {
    d: "M142 150H138V154H142V150Z",
    fill: "white"
  })), _path467 || (_path467 = /*#__PURE__*/React.createElement("path", {
    d: "M142 154H138V158H142V154Z",
    fill: "white"
  })), _path468 || (_path468 = /*#__PURE__*/React.createElement("path", {
    d: "M142 158H138V162H142V158Z",
    fill: "white"
  })), _path469 || (_path469 = /*#__PURE__*/React.createElement("path", {
    d: "M142 162H138V166H142V162Z",
    fill: "white"
  })), _path470 || (_path470 = /*#__PURE__*/React.createElement("path", {
    d: "M142 166H138V170H142V166Z",
    fill: "white"
  })), _path471 || (_path471 = /*#__PURE__*/React.createElement("path", {
    d: "M142 170H138V174H140C140.53 174 141.039 173.789 141.414 173.414C141.789 173.039 142 172.53 142 172",
    fill: "white"
  })), _path472 || (_path472 = /*#__PURE__*/React.createElement("path", {
    d: "M146 18H142V22H146V18Z",
    fill: "white"
  })), _path473 || (_path473 = /*#__PURE__*/React.createElement("path", {
    d: "M144 34C145.105 34 146 33.1046 146 32C146 30.8954 145.105 30 144 30C142.895 30 142 30.8954 142 32C142 33.1046 142.895 34 144 34Z",
    fill: "white"
  })), _path474 || (_path474 = /*#__PURE__*/React.createElement("path", {
    d: "M146 42V38H144C143.47 38 142.961 38.2107 142.586 38.5858C142.211 38.9609 142 39.4696 142 40C142 40.5304 142.211 41.0391 142.586 41.4142C142.961 41.7893 143.47 42 144 42",
    fill: "white"
  })), _path475 || (_path475 = /*#__PURE__*/React.createElement("path", {
    d: "M142 46V50H146V48C146 47.4696 145.789 46.9609 145.414 46.5858C145.039 46.2107 144.53 46 144 46",
    fill: "white"
  })), _path476 || (_path476 = /*#__PURE__*/React.createElement("path", {
    d: "M146 50H142V54H146V50Z",
    fill: "white"
  })), _path477 || (_path477 = /*#__PURE__*/React.createElement("path", {
    d: "M144 62C145.105 62 146 61.1046 146 60C146 58.8954 145.105 58 144 58C142.895 58 142 58.8954 142 60C142 61.1046 142.895 62 144 62Z",
    fill: "white"
  })), _path478 || (_path478 = /*#__PURE__*/React.createElement("path", {
    d: "M142 74H146V70H144C143.47 70 142.961 70.2107 142.586 70.5858C142.211 70.9609 142 71.4696 142 72",
    fill: "white"
  })), _path479 || (_path479 = /*#__PURE__*/React.createElement("path", {
    d: "M146 74H142V78H146V74Z",
    fill: "white"
  })), _path480 || (_path480 = /*#__PURE__*/React.createElement("path", {
    d: "M146 78H142V82H146V78Z",
    fill: "white"
  })), _path481 || (_path481 = /*#__PURE__*/React.createElement("path", {
    d: "M146 82H142V86H146V82Z",
    fill: "white"
  })), _path482 || (_path482 = /*#__PURE__*/React.createElement("path", {
    d: "M146 86H142V90H146V86Z",
    fill: "white"
  })), _path483 || (_path483 = /*#__PURE__*/React.createElement("path", {
    d: "M146 90H142V94H146V90Z",
    fill: "white"
  })), _path484 || (_path484 = /*#__PURE__*/React.createElement("path", {
    d: "M146 94H142V98H146V94Z",
    fill: "white"
  })), _path485 || (_path485 = /*#__PURE__*/React.createElement("path", {
    d: "M146 98H142V102H144C144.53 102 145.039 101.789 145.414 101.414C145.789 101.039 146 100.53 146 100",
    fill: "white"
  })), _path486 || (_path486 = /*#__PURE__*/React.createElement("path", {
    d: "M142 114H146V112C146 111.47 145.789 110.961 145.414 110.586C145.039 110.211 144.53 110 144 110C143.47 110 142.961 110.211 142.586 110.586C142.211 110.961 142 111.47 142 112",
    fill: "white"
  })), _path487 || (_path487 = /*#__PURE__*/React.createElement("path", {
    d: "M146 114H142V118H146V114Z",
    fill: "white"
  })), _path488 || (_path488 = /*#__PURE__*/React.createElement("path", {
    d: "M142 126V130H144C144.53 130 145.039 129.789 145.414 129.414C145.789 129.039 146 128.53 146 128C146 127.47 145.789 126.961 145.414 126.586C145.039 126.211 144.53 126 144 126",
    fill: "white"
  })), _path489 || (_path489 = /*#__PURE__*/React.createElement("path", {
    d: "M142 150H146V146H144C143.47 146 142.961 146.211 142.586 146.586C142.211 146.961 142 147.47 142 148",
    fill: "white"
  })), _path490 || (_path490 = /*#__PURE__*/React.createElement("path", {
    d: "M146 150H142V154H146V150Z",
    fill: "white"
  })), _path491 || (_path491 = /*#__PURE__*/React.createElement("path", {
    d: "M146 154H142V158H146V154Z",
    fill: "white"
  })), _path492 || (_path492 = /*#__PURE__*/React.createElement("path", {
    d: "M146 158H142V162H146V158Z",
    fill: "white"
  })), _path493 || (_path493 = /*#__PURE__*/React.createElement("path", {
    d: "M142 166V170H144C144.53 170 145.039 169.789 145.414 169.414C145.789 169.039 146 168.53 146 168C146 167.47 145.789 166.961 145.414 166.586C145.039 166.211 144.53 166 144 166",
    fill: "white"
  })), _path494 || (_path494 = /*#__PURE__*/React.createElement("path", {
    d: "M146 182V178H144C143.47 178 142.961 178.211 142.586 178.586C142.211 178.961 142 179.47 142 180C142 180.53 142.211 181.039 142.586 181.414C142.961 181.789 143.47 182 144 182",
    fill: "white"
  })), _path495 || (_path495 = /*#__PURE__*/React.createElement("path", {
    d: "M146 18V22H148C148.53 22 149.039 21.7893 149.414 21.4142C149.789 21.0391 150 20.5304 150 20C150 19.4696 149.789 18.9609 149.414 18.5858C149.039 18.2107 148.53 18 148 18",
    fill: "white"
  })), _path496 || (_path496 = /*#__PURE__*/React.createElement("path", {
    d: "M146 38H150V36C150 35.4696 149.789 34.9609 149.414 34.5858C149.039 34.2107 148.53 34 148 34C147.47 34 146.961 34.2107 146.586 34.5858C146.211 34.9609 146 35.4696 146 36",
    fill: "white"
  })), _path497 || (_path497 = /*#__PURE__*/React.createElement("path", {
    d: "M150 38H146V42H150V38Z",
    fill: "white"
  })), _path498 || (_path498 = /*#__PURE__*/React.createElement("path", {
    d: "M150 42H146V44C146 44.5304 146.211 45.0391 146.586 45.4142C146.961 45.7893 147.47 46 148 46C148.53 46 149.039 45.7893 149.414 45.4142C149.789 45.0391 150 44.5304 150 44",
    fill: "white"
  })), _path499 || (_path499 = /*#__PURE__*/React.createElement("path", {
    d: "M150 50H146V54H150V50Z",
    fill: "white"
  })), _path500 || (_path500 = /*#__PURE__*/React.createElement("path", {
    d: "M150 58V54H146V56C146 56.5304 146.211 57.0391 146.586 57.4142C146.961 57.7893 147.47 58 148 58",
    fill: "white"
  })), _path501 || (_path501 = /*#__PURE__*/React.createElement("path", {
    d: "M148 66C149.105 66 150 65.1046 150 64C150 62.8954 149.105 62 148 62C146.895 62 146 62.8954 146 64C146 65.1046 146.895 66 148 66Z",
    fill: "white"
  })), _path502 || (_path502 = /*#__PURE__*/React.createElement("path", {
    d: "M146 70V74H150V72C150 71.4696 149.789 70.9609 149.414 70.5858C149.039 70.2107 148.53 70 148 70",
    fill: "white"
  })), _path503 || (_path503 = /*#__PURE__*/React.createElement("path", {
    d: "M150 74H146V78H150V74Z",
    fill: "white"
  })), _path504 || (_path504 = /*#__PURE__*/React.createElement("path", {
    d: "M150 78H146V82H150V78Z",
    fill: "white"
  })), _path505 || (_path505 = /*#__PURE__*/React.createElement("path", {
    d: "M150 82H146V86H148C148.53 86 149.039 85.7893 149.414 85.4142C149.789 85.0391 150 84.5304 150 84",
    fill: "white"
  })), _path506 || (_path506 = /*#__PURE__*/React.createElement("path", {
    d: "M146 90V94H150V92C150 91.4696 149.789 90.9609 149.414 90.5858C149.039 90.2107 148.53 90 148 90",
    fill: "white"
  })), _path507 || (_path507 = /*#__PURE__*/React.createElement("path", {
    d: "M150 94H146V98H148C148.53 98 149.039 97.7893 149.414 97.4142C149.789 97.0391 150 96.5304 150 96",
    fill: "white"
  })), _path508 || (_path508 = /*#__PURE__*/React.createElement("path", {
    d: "M148 106C149.105 106 150 105.105 150 104C150 102.895 149.105 102 148 102C146.895 102 146 102.895 146 104C146 105.105 146.895 106 148 106Z",
    fill: "white"
  })), _path509 || (_path509 = /*#__PURE__*/React.createElement("path", {
    d: "M146 114V118H150V116C150 115.47 149.789 114.961 149.414 114.586C149.039 114.211 148.53 114 148 114",
    fill: "white"
  })), _path510 || (_path510 = /*#__PURE__*/React.createElement("path", {
    d: "M150 118H146V122H150V118Z",
    fill: "white"
  })), _path511 || (_path511 = /*#__PURE__*/React.createElement("path", {
    d: "M150 126V122H146V124C146 124.53 146.211 125.039 146.586 125.414C146.961 125.789 147.47 126 148 126",
    fill: "white"
  })), _path512 || (_path512 = /*#__PURE__*/React.createElement("path", {
    d: "M148 138C149.105 138 150 137.105 150 136C150 134.895 149.105 134 148 134C146.895 134 146 134.895 146 136C146 137.105 146.895 138 148 138Z",
    fill: "white"
  })), _path513 || (_path513 = /*#__PURE__*/React.createElement("path", {
    d: "M150 146H146V150H150V146Z",
    fill: "white"
  })), _path514 || (_path514 = /*#__PURE__*/React.createElement("path", {
    d: "M150 150H146V154H150V150Z",
    fill: "white"
  })), _path515 || (_path515 = /*#__PURE__*/React.createElement("path", {
    d: "M150 154H146V158H150V154Z",
    fill: "white"
  })), _path516 || (_path516 = /*#__PURE__*/React.createElement("path", {
    d: "M150 158H146V162H150V158Z",
    fill: "white"
  })), _path517 || (_path517 = /*#__PURE__*/React.createElement("path", {
    d: "M150 166V162H146V164C146 164.53 146.211 165.039 146.586 165.414C146.961 165.789 147.47 166 148 166",
    fill: "white"
  })), _path518 || (_path518 = /*#__PURE__*/React.createElement("path", {
    d: "M148 174C149.105 174 150 173.105 150 172C150 170.895 149.105 170 148 170C146.895 170 146 170.895 146 172C146 173.105 146.895 174 148 174Z",
    fill: "white"
  })), _path519 || (_path519 = /*#__PURE__*/React.createElement("path", {
    d: "M150 178H146V182H150V178Z",
    fill: "white"
  })), _path520 || (_path520 = /*#__PURE__*/React.createElement("path", {
    d: "M154 50H150V54H154V50Z",
    fill: "white"
  })), _path521 || (_path521 = /*#__PURE__*/React.createElement("path", {
    d: "M154 54H150V58H154V54Z",
    fill: "white"
  })), _path522 || (_path522 = /*#__PURE__*/React.createElement("path", {
    d: "M154 58H150V60C150 60.5304 150.211 61.0391 150.586 61.4142C150.961 61.7893 151.47 62 152 62C152.53 62 153.039 61.7893 153.414 61.4142C153.789 61.0391 154 60.5304 154 60",
    fill: "white"
  })), _path523 || (_path523 = /*#__PURE__*/React.createElement("path", {
    d: "M150 78V82H152C152.53 82 153.039 81.7893 153.414 81.4142C153.789 81.0391 154 80.5304 154 80C154 79.4696 153.789 78.9609 153.414 78.5858C153.039 78.2107 152.53 78 152 78",
    fill: "white"
  })), _path524 || (_path524 = /*#__PURE__*/React.createElement("path", {
    d: "M154 90V86H152C151.47 86 150.961 86.2107 150.586 86.5858C150.211 86.9609 150 87.4696 150 88C150 88.5304 150.211 89.0391 150.586 89.4142C150.961 89.7893 151.47 90 152 90",
    fill: "white"
  })), _path525 || (_path525 = /*#__PURE__*/React.createElement("path", {
    d: "M154 102V98H152C151.47 98 150.961 98.2107 150.586 98.5858C150.211 98.9609 150 99.4696 150 100C150 100.53 150.211 101.039 150.586 101.414C150.961 101.789 151.47 102 152 102",
    fill: "white"
  })), _path526 || (_path526 = /*#__PURE__*/React.createElement("path", {
    d: "M150 110H154V108C154 107.47 153.789 106.961 153.414 106.586C153.039 106.211 152.53 106 152 106C151.47 106 150.961 106.211 150.586 106.586C150.211 106.961 150 107.47 150 108",
    fill: "white"
  })), _path527 || (_path527 = /*#__PURE__*/React.createElement("path", {
    d: "M154 110H150V112C150 112.53 150.211 113.039 150.586 113.414C150.961 113.789 151.47 114 152 114C152.53 114 153.039 113.789 153.414 113.414C153.789 113.039 154 112.53 154 112",
    fill: "white"
  })), _path528 || (_path528 = /*#__PURE__*/React.createElement("path", {
    d: "M154 122H150V126H154V122Z",
    fill: "white"
  })), _path529 || (_path529 = /*#__PURE__*/React.createElement("path", {
    d: "M152 134C153.105 134 154 133.105 154 132C154 130.895 153.105 130 152 130C150.895 130 150 130.895 150 132C150 133.105 150.895 134 152 134Z",
    fill: "white"
  })), _path530 || (_path530 = /*#__PURE__*/React.createElement("path", {
    d: "M154 146H150V150H154V146Z",
    fill: "white"
  })), _path531 || (_path531 = /*#__PURE__*/React.createElement("path", {
    d: "M154 162H150V166H154V162Z",
    fill: "white"
  })), _path532 || (_path532 = /*#__PURE__*/React.createElement("path", {
    d: "M150 178H154V174H152C151.47 174 150.961 174.211 150.586 174.586C150.211 174.961 150 175.47 150 176",
    fill: "white"
  })), _path533 || (_path533 = /*#__PURE__*/React.createElement("path", {
    d: "M154 178H150V182H152C152.53 182 153.039 181.789 153.414 181.414C153.789 181.039 154 180.53 154 180",
    fill: "white"
  })), _path534 || (_path534 = /*#__PURE__*/React.createElement("path", {
    d: "M158 50H154V54H158V50Z",
    fill: "white"
  })), _path535 || (_path535 = /*#__PURE__*/React.createElement("path", {
    d: "M154 66H158V64C158 63.4696 157.789 62.9609 157.414 62.5858C157.039 62.2107 156.53 62 156 62C155.47 62 154.961 62.2107 154.586 62.5858C154.211 62.9609 154 63.4696 154 64",
    fill: "white"
  })), _path536 || (_path536 = /*#__PURE__*/React.createElement("path", {
    d: "M158 66H154V70H158V66Z",
    fill: "white"
  })), _path537 || (_path537 = /*#__PURE__*/React.createElement("path", {
    d: "M158 70H154V74H158V70Z",
    fill: "white"
  })), _path538 || (_path538 = /*#__PURE__*/React.createElement("path", {
    d: "M158 74H154V76C154 76.5304 154.211 77.0391 154.586 77.4142C154.961 77.7893 155.47 78 156 78C156.53 78 157.039 77.7893 157.414 77.4142C157.789 77.0391 158 76.5304 158 76",
    fill: "white"
  })), _path539 || (_path539 = /*#__PURE__*/React.createElement("path", {
    d: "M158 86H154V90H158V86Z",
    fill: "white"
  })), _path540 || (_path540 = /*#__PURE__*/React.createElement("path", {
    d: "M158 94V90H154V92C154 92.5304 154.211 93.0391 154.586 93.4142C154.961 93.7893 155.47 94 156 94",
    fill: "white"
  })), _path541 || (_path541 = /*#__PURE__*/React.createElement("path", {
    d: "M154 98V102H158V100C158 99.4696 157.789 98.9609 157.414 98.5858C157.039 98.2107 156.53 98 156 98",
    fill: "white"
  })), _path542 || (_path542 = /*#__PURE__*/React.createElement("path", {
    d: "M158 102H154V104C154 104.53 154.211 105.039 154.586 105.414C154.961 105.789 155.47 106 156 106C156.53 106 157.039 105.789 157.414 105.414C157.789 105.039 158 104.53 158 104",
    fill: "white"
  })), _path543 || (_path543 = /*#__PURE__*/React.createElement("path", {
    d: "M158 118V114H156C155.47 114 154.961 114.211 154.586 114.586C154.211 114.961 154 115.47 154 116C154 116.53 154.211 117.039 154.586 117.414C154.961 117.789 155.47 118 156 118",
    fill: "white"
  })), _path544 || (_path544 = /*#__PURE__*/React.createElement("path", {
    d: "M158 122H154V126H158V122Z",
    fill: "white"
  })), _path545 || (_path545 = /*#__PURE__*/React.createElement("path", {
    d: "M158 126H154V128C154 128.53 154.211 129.039 154.586 129.414C154.961 129.789 155.47 130 156 130C156.53 130 157.039 129.789 157.414 129.414C157.789 129.039 158 128.53 158 128",
    fill: "white"
  })), _path546 || (_path546 = /*#__PURE__*/React.createElement("path", {
    d: "M156 138C157.105 138 158 137.105 158 136C158 134.895 157.105 134 156 134C154.895 134 154 134.895 154 136C154 137.105 154.895 138 156 138Z",
    fill: "white"
  })), _path547 || (_path547 = /*#__PURE__*/React.createElement("path", {
    d: "M154 146H158V142H156C155.47 142 154.961 142.211 154.586 142.586C154.211 142.961 154 143.47 154 144",
    fill: "white"
  })), _path548 || (_path548 = /*#__PURE__*/React.createElement("path", {
    d: "M158 146H154V150H158V146Z",
    fill: "white"
  })), _path549 || (_path549 = /*#__PURE__*/React.createElement("path", {
    d: "M156 158C157.105 158 158 157.105 158 156C158 154.895 157.105 154 156 154C154.895 154 154 154.895 154 156C154 157.105 154.895 158 156 158Z",
    fill: "white"
  })), _path550 || (_path550 = /*#__PURE__*/React.createElement("path", {
    d: "M158 162H154V166H158V162Z",
    fill: "white"
  })), _path551 || (_path551 = /*#__PURE__*/React.createElement("path", {
    d: "M158 170V166H154V168C154 168.53 154.211 169.039 154.586 169.414C154.961 169.789 155.47 170 156 170",
    fill: "white"
  })), _path552 || (_path552 = /*#__PURE__*/React.createElement("path", {
    d: "M154 174V178H156C156.53 178 157.039 177.789 157.414 177.414C157.789 177.039 158 176.53 158 176C158 175.47 157.789 174.961 157.414 174.586C157.039 174.211 156.53 174 156 174",
    fill: "white"
  })), _path553 || (_path553 = /*#__PURE__*/React.createElement("path", {
    d: "M162 50H158V54H162V50Z",
    fill: "white"
  })), _path554 || (_path554 = /*#__PURE__*/React.createElement("path", {
    d: "M162 62V58H160C159.47 58 158.961 58.2107 158.586 58.5858C158.211 58.9609 158 59.4696 158 60C158 60.5304 158.211 61.0391 158.586 61.4142C158.961 61.7893 159.47 62 160 62",
    fill: "white"
  })), _path555 || (_path555 = /*#__PURE__*/React.createElement("path", {
    d: "M158 86V90H162V88C162 87.4696 161.789 86.9609 161.414 86.5858C161.039 86.2107 160.53 86 160 86",
    fill: "white"
  })), _path556 || (_path556 = /*#__PURE__*/React.createElement("path", {
    d: "M162 90H158V94H162V90Z",
    fill: "white"
  })), _path557 || (_path557 = /*#__PURE__*/React.createElement("path", {
    d: "M162 98V94H158V96C158 96.5304 158.211 97.0391 158.586 97.4142C158.961 97.7893 159.47 98 160 98",
    fill: "white"
  })), _path558 || (_path558 = /*#__PURE__*/React.createElement("path", {
    d: "M158 114H162V112C162 111.47 161.789 110.961 161.414 110.586C161.039 110.211 160.53 110 160 110C159.47 110 158.961 110.211 158.586 110.586C158.211 110.961 158 111.47 158 112",
    fill: "white"
  })), _path559 || (_path559 = /*#__PURE__*/React.createElement("path", {
    d: "M162 114H158V118H160C160.53 118 161.039 117.789 161.414 117.414C161.789 117.039 162 116.53 162 116",
    fill: "white"
  })), _path560 || (_path560 = /*#__PURE__*/React.createElement("path", {
    d: "M158 122V126H160C160.53 126 161.039 125.789 161.414 125.414C161.789 125.039 162 124.53 162 124C162 123.47 161.789 122.961 161.414 122.586C161.039 122.211 160.53 122 160 122",
    fill: "white"
  })), _path561 || (_path561 = /*#__PURE__*/React.createElement("path", {
    d: "M160 134C161.105 134 162 133.105 162 132C162 130.895 161.105 130 160 130C158.895 130 158 130.895 158 132C158 133.105 158.895 134 160 134Z",
    fill: "white"
  })), _path562 || (_path562 = /*#__PURE__*/React.createElement("path", {
    d: "M158 142H162V138H160C159.47 138 158.961 138.211 158.586 138.586C158.211 138.961 158 139.47 158 140",
    fill: "white"
  })), _path563 || (_path563 = /*#__PURE__*/React.createElement("path", {
    d: "M162 142H158V146H162V142Z",
    fill: "white"
  })), _path564 || (_path564 = /*#__PURE__*/React.createElement("path", {
    d: "M162 146H158V150H162V146Z",
    fill: "white"
  })), _path565 || (_path565 = /*#__PURE__*/React.createElement("path", {
    d: "M162 162H158V166H162V162Z",
    fill: "white"
  })), _path566 || (_path566 = /*#__PURE__*/React.createElement("path", {
    d: "M162 166H158V170H160C160.53 170 161.039 169.789 161.414 169.414C161.789 169.039 162 168.53 162 168",
    fill: "white"
  })), _path567 || (_path567 = /*#__PURE__*/React.createElement("path", {
    d: "M166 50H162V54H166V50Z",
    fill: "white"
  })), _path568 || (_path568 = /*#__PURE__*/React.createElement("path", {
    d: "M166 58H162V62H166V58Z",
    fill: "white"
  })), _path569 || (_path569 = /*#__PURE__*/React.createElement("path", {
    d: "M166 62H162V66H166V62Z",
    fill: "white"
  })), _path570 || (_path570 = /*#__PURE__*/React.createElement("path", {
    d: "M166 66H162V68C162 68.5304 162.211 69.0391 162.586 69.4142C162.961 69.7893 163.47 70 164 70C164.53 70 165.039 69.7893 165.414 69.4142C165.789 69.0391 166 68.5304 166 68",
    fill: "white"
  })), _path571 || (_path571 = /*#__PURE__*/React.createElement("path", {
    d: "M166 82V78H164C163.47 78 162.961 78.2107 162.586 78.5858C162.211 78.9609 162 79.4696 162 80C162 80.5304 162.211 81.0391 162.586 81.4142C162.961 81.7893 163.47 82 164 82",
    fill: "white"
  })), _path572 || (_path572 = /*#__PURE__*/React.createElement("path", {
    d: "M162 94V98H166V96C166 95.4696 165.789 94.9609 165.414 94.5858C165.039 94.2107 164.53 94 164 94",
    fill: "white"
  })), _path573 || (_path573 = /*#__PURE__*/React.createElement("path", {
    d: "M166 98H162V102H166V98Z",
    fill: "white"
  })), _path574 || (_path574 = /*#__PURE__*/React.createElement("path", {
    d: "M166 102H162V106H166V102Z",
    fill: "white"
  })), _path575 || (_path575 = /*#__PURE__*/React.createElement("path", {
    d: "M166 110V106H162V108C162 108.53 162.211 109.039 162.586 109.414C162.961 109.789 163.47 110 164 110",
    fill: "white"
  })), _path576 || (_path576 = /*#__PURE__*/React.createElement("path", {
    d: "M164 122C165.105 122 166 121.105 166 120C166 118.895 165.105 118 164 118C162.895 118 162 118.895 162 120C162 121.105 162.895 122 164 122Z",
    fill: "white"
  })), _path577 || (_path577 = /*#__PURE__*/React.createElement("path", {
    d: "M164 130C165.105 130 166 129.105 166 128C166 126.895 165.105 126 164 126C162.895 126 162 126.895 162 128C162 129.105 162.895 130 164 130Z",
    fill: "white"
  })), _path578 || (_path578 = /*#__PURE__*/React.createElement("path", {
    d: "M162 138H166V136C166 135.47 165.789 134.961 165.414 134.586C165.039 134.211 164.53 134 164 134C163.47 134 162.961 134.211 162.586 134.586C162.211 134.961 162 135.47 162 136",
    fill: "white"
  })), _path579 || (_path579 = /*#__PURE__*/React.createElement("path", {
    d: "M166 138H162V142H164C164.53 142 165.039 141.789 165.414 141.414C165.789 141.039 166 140.53 166 140",
    fill: "white"
  })), _path580 || (_path580 = /*#__PURE__*/React.createElement("path", {
    d: "M166 146H162V150H166V146Z",
    fill: "white"
  })), _path581 || (_path581 = /*#__PURE__*/React.createElement("path", {
    d: "M166 150H162V154H166V150Z",
    fill: "white"
  })), _path582 || (_path582 = /*#__PURE__*/React.createElement("path", {
    d: "M166 154H162V158H166V154Z",
    fill: "white"
  })), _path583 || (_path583 = /*#__PURE__*/React.createElement("path", {
    d: "M166 158H162V162H166V158Z",
    fill: "white"
  })), _path584 || (_path584 = /*#__PURE__*/React.createElement("path", {
    d: "M166 162H162V166H164C164.53 166 165.039 165.789 165.414 165.414C165.789 165.039 166 164.53 166 164",
    fill: "white"
  })), _path585 || (_path585 = /*#__PURE__*/React.createElement("path", {
    d: "M166 174V170H164C163.47 170 162.961 170.211 162.586 170.586C162.211 170.961 162 171.47 162 172C162 172.53 162.211 173.039 162.586 173.414C162.961 173.789 163.47 174 164 174",
    fill: "white"
  })), _path586 || (_path586 = /*#__PURE__*/React.createElement("path", {
    d: "M170 50H166V54H170V50Z",
    fill: "white"
  })), _path587 || (_path587 = /*#__PURE__*/React.createElement("path", {
    d: "M170 58H166V62H170V58Z",
    fill: "white"
  })), _path588 || (_path588 = /*#__PURE__*/React.createElement("path", {
    d: "M170 62H166V66H168C168.53 66 169.039 65.7893 169.414 65.4142C169.789 65.0391 170 64.5304 170 64",
    fill: "white"
  })), _path589 || (_path589 = /*#__PURE__*/React.createElement("path", {
    d: "M166 74H170V72C170 71.4696 169.789 70.9609 169.414 70.5858C169.039 70.2107 168.53 70 168 70C167.47 70 166.961 70.2107 166.586 70.5858C166.211 70.9609 166 71.4696 166 72",
    fill: "white"
  })), _path590 || (_path590 = /*#__PURE__*/React.createElement("path", {
    d: "M170 74H166V78H170V74Z",
    fill: "white"
  })), _path591 || (_path591 = /*#__PURE__*/React.createElement("path", {
    d: "M170 78H166V82H170V78Z",
    fill: "white"
  })), _path592 || (_path592 = /*#__PURE__*/React.createElement("path", {
    d: "M170 82H166V84C166 84.5304 166.211 85.0391 166.586 85.4142C166.961 85.7893 167.47 86 168 86C168.53 86 169.039 85.7893 169.414 85.4142C169.789 85.0391 170 84.5304 170 84",
    fill: "white"
  })), _path593 || (_path593 = /*#__PURE__*/React.createElement("path", {
    d: "M170 94V90H168C167.47 90 166.961 90.2107 166.586 90.5858C166.211 90.9609 166 91.4696 166 92C166 92.5304 166.211 93.0391 166.586 93.4142C166.961 93.7893 167.47 94 168 94",
    fill: "white"
  })), _path594 || (_path594 = /*#__PURE__*/React.createElement("path", {
    d: "M170 98H166V102H170V98Z",
    fill: "white"
  })), _path595 || (_path595 = /*#__PURE__*/React.createElement("path", {
    d: "M170 106H166V110H170V106Z",
    fill: "white"
  })), _path596 || (_path596 = /*#__PURE__*/React.createElement("path", {
    d: "M170 110H166V112C166 112.53 166.211 113.039 166.586 113.414C166.961 113.789 167.47 114 168 114C168.53 114 169.039 113.789 169.414 113.414C169.789 113.039 170 112.53 170 112",
    fill: "white"
  })), _path597 || (_path597 = /*#__PURE__*/React.createElement("path", {
    d: "M168 126C169.105 126 170 125.105 170 124C170 122.895 169.105 122 168 122C166.895 122 166 122.895 166 124C166 125.105 166.895 126 168 126Z",
    fill: "white"
  })), _path598 || (_path598 = /*#__PURE__*/React.createElement("path", {
    d: "M170 134V130H168C167.47 130 166.961 130.211 166.586 130.586C166.211 130.961 166 131.47 166 132C166 132.53 166.211 133.039 166.586 133.414C166.961 133.789 167.47 134 168 134",
    fill: "white"
  })), _path599 || (_path599 = /*#__PURE__*/React.createElement("path", {
    d: "M170 146H166V150H170V146Z",
    fill: "white"
  })), _path600 || (_path600 = /*#__PURE__*/React.createElement("path", {
    d: "M170 150H166V154H170V150Z",
    fill: "white"
  })), _path601 || (_path601 = /*#__PURE__*/React.createElement("path", {
    d: "M170 158H166V162H170V158Z",
    fill: "white"
  })), _path602 || (_path602 = /*#__PURE__*/React.createElement("path", {
    d: "M166 170H170V168C170 167.47 169.789 166.961 169.414 166.586C169.039 166.211 168.53 166 168 166C167.47 166 166.961 166.211 166.586 166.586C166.211 166.961 166 167.47 166 168",
    fill: "white"
  })), _path603 || (_path603 = /*#__PURE__*/React.createElement("path", {
    d: "M170 170H166V174H170V170Z",
    fill: "white"
  })), _path604 || (_path604 = /*#__PURE__*/React.createElement("path", {
    d: "M170 174H166V176C166 176.53 166.211 177.039 166.586 177.414C166.961 177.789 167.47 178 168 178C168.53 178 169.039 177.789 169.414 177.414C169.789 177.039 170 176.53 170 176",
    fill: "white"
  })), _path605 || (_path605 = /*#__PURE__*/React.createElement("path", {
    d: "M174 50H170V54H174V50Z",
    fill: "white"
  })), _path606 || (_path606 = /*#__PURE__*/React.createElement("path", {
    d: "M174 58H170V62H174V58Z",
    fill: "white"
  })), _path607 || (_path607 = /*#__PURE__*/React.createElement("path", {
    d: "M174 70V66H172C171.47 66 170.961 66.2107 170.586 66.5858C170.211 66.9609 170 67.4696 170 68C170 68.5304 170.211 69.0391 170.586 69.4142C170.961 69.7893 171.47 70 172 70",
    fill: "white"
  })), _path608 || (_path608 = /*#__PURE__*/React.createElement("path", {
    d: "M174 78H170V82H174V78Z",
    fill: "white"
  })), _path609 || (_path609 = /*#__PURE__*/React.createElement("path", {
    d: "M170 90H174V88C174 87.4696 173.789 86.9609 173.414 86.5858C173.039 86.2107 172.53 86 172 86C171.47 86 170.961 86.2107 170.586 86.5858C170.211 86.9609 170 87.4696 170 88",
    fill: "white"
  })), _path610 || (_path610 = /*#__PURE__*/React.createElement("path", {
    d: "M174 90H170V94H174V90Z",
    fill: "white"
  })), _path611 || (_path611 = /*#__PURE__*/React.createElement("path", {
    d: "M170 98V102H172C172.53 102 173.039 101.789 173.414 101.414C173.789 101.039 174 100.53 174 100C174 99.4696 173.789 98.9609 173.414 98.5858C173.039 98.2107 172.53 98 172 98",
    fill: "white"
  })), _path612 || (_path612 = /*#__PURE__*/React.createElement("path", {
    d: "M174 106H170V110H174V106Z",
    fill: "white"
  })), _path613 || (_path613 = /*#__PURE__*/React.createElement("path", {
    d: "M170 130H174V128C174 127.47 173.789 126.961 173.414 126.586C173.039 126.211 172.53 126 172 126C171.47 126 170.961 126.211 170.586 126.586C170.211 126.961 170 127.47 170 128",
    fill: "white"
  })), _path614 || (_path614 = /*#__PURE__*/React.createElement("path", {
    d: "M174 130H170V134H174V130Z",
    fill: "white"
  })), _path615 || (_path615 = /*#__PURE__*/React.createElement("path", {
    d: "M170 142H174V138H172C171.47 138 170.961 138.211 170.586 138.586C170.211 138.961 170 139.47 170 140",
    fill: "white"
  })), _path616 || (_path616 = /*#__PURE__*/React.createElement("path", {
    d: "M174 142H170V146H174V142Z",
    fill: "white"
  })), _path617 || (_path617 = /*#__PURE__*/React.createElement("path", {
    d: "M174 146H170V150H174V146Z",
    fill: "white"
  })), _path618 || (_path618 = /*#__PURE__*/React.createElement("path", {
    d: "M174 150H170V154H174V150Z",
    fill: "white"
  })), _path619 || (_path619 = /*#__PURE__*/React.createElement("path", {
    d: "M174 154H170V158H174V154Z",
    fill: "white"
  })), _path620 || (_path620 = /*#__PURE__*/React.createElement("path", {
    d: "M174 158H170V162H174V158Z",
    fill: "white"
  })), _path621 || (_path621 = /*#__PURE__*/React.createElement("path", {
    d: "M174 166V162H170V164C170 164.53 170.211 165.039 170.586 165.414C170.961 165.789 171.47 166 172 166",
    fill: "white"
  })), _path622 || (_path622 = /*#__PURE__*/React.createElement("path", {
    d: "M170 170V174H172C172.53 174 173.039 173.789 173.414 173.414C173.789 173.039 174 172.53 174 172C174 171.47 173.789 170.961 173.414 170.586C173.039 170.211 172.53 170 172 170",
    fill: "white"
  })), _path623 || (_path623 = /*#__PURE__*/React.createElement("path", {
    d: "M174 50V54H176C176.53 54 177.039 53.7893 177.414 53.4142C177.789 53.0391 178 52.5304 178 52C178 51.4696 177.789 50.9609 177.414 50.5858C177.039 50.2107 176.53 50 176 50",
    fill: "white"
  })), _path624 || (_path624 = /*#__PURE__*/React.createElement("path", {
    d: "M174 58V62H176C176.53 62 177.039 61.7893 177.414 61.4142C177.789 61.0391 178 60.5304 178 60C178 59.4696 177.789 58.9609 177.414 58.5858C177.039 58.2107 176.53 58 176 58",
    fill: "white"
  })), _path625 || (_path625 = /*#__PURE__*/React.createElement("path", {
    d: "M178 66H174V70H178V66Z",
    fill: "white"
  })), _path626 || (_path626 = /*#__PURE__*/React.createElement("path", {
    d: "M178 78H174V82H178V78Z",
    fill: "white"
  })), _path627 || (_path627 = /*#__PURE__*/React.createElement("path", {
    d: "M174 90V94H178V92C178 91.4696 177.789 90.9609 177.414 90.5858C177.039 90.2107 176.53 90 176 90",
    fill: "white"
  })), _path628 || (_path628 = /*#__PURE__*/React.createElement("path", {
    d: "M178 98V94H174V96C174 96.5304 174.211 97.0391 174.586 97.4142C174.961 97.7893 175.47 98 176 98",
    fill: "white"
  })), _path629 || (_path629 = /*#__PURE__*/React.createElement("path", {
    d: "M174 106H178V104C178 103.47 177.789 102.961 177.414 102.586C177.039 102.211 176.53 102 176 102C175.47 102 174.961 102.211 174.586 102.586C174.211 102.961 174 103.47 174 104",
    fill: "white"
  })), _path630 || (_path630 = /*#__PURE__*/React.createElement("path", {
    d: "M178 106H174V110H178V106Z",
    fill: "white"
  })), _path631 || (_path631 = /*#__PURE__*/React.createElement("path", {
    d: "M178 130H174V134H178V130Z",
    fill: "white"
  })), _path632 || (_path632 = /*#__PURE__*/React.createElement("path", {
    d: "M174 138V142H176C176.53 142 177.039 141.789 177.414 141.414C177.789 141.039 178 140.53 178 140C178 139.47 177.789 138.961 177.414 138.586C177.039 138.211 176.53 138 176 138",
    fill: "white"
  })), _path633 || (_path633 = /*#__PURE__*/React.createElement("path", {
    d: "M174 146V150H176C176.53 150 177.039 149.789 177.414 149.414C177.789 149.039 178 148.53 178 148C178 147.47 177.789 146.961 177.414 146.586C177.039 146.211 176.53 146 176 146",
    fill: "white"
  })), _path634 || (_path634 = /*#__PURE__*/React.createElement("path", {
    d: "M178 154H174V158H178V154Z",
    fill: "white"
  })), _path635 || (_path635 = /*#__PURE__*/React.createElement("path", {
    d: "M178 162H174V166H178V162Z",
    fill: "white"
  })), _path636 || (_path636 = /*#__PURE__*/React.createElement("path", {
    d: "M178 166H174V168C174 168.53 174.211 169.039 174.586 169.414C174.961 169.789 175.47 170 176 170C176.53 170 177.039 169.789 177.414 169.414C177.789 169.039 178 168.53 178 168",
    fill: "white"
  })), _path637 || (_path637 = /*#__PURE__*/React.createElement("path", {
    d: "M176 178C177.105 178 178 177.105 178 176C178 174.895 177.105 174 176 174C174.895 174 174 174.895 174 176C174 177.105 174.895 178 176 178Z",
    fill: "white"
  })), _path638 || (_path638 = /*#__PURE__*/React.createElement("path", {
    d: "M178 66H182V64C182 63.4696 181.789 62.9609 181.414 62.5858C181.039 62.2107 180.53 62 180 62C179.47 62 178.961 62.2107 178.586 62.5858C178.211 62.9609 178 63.4696 178 64",
    fill: "white"
  })), _path639 || (_path639 = /*#__PURE__*/React.createElement("path", {
    d: "M182 66H178V70H180C180.53 70 181.039 69.7893 181.414 69.4142C181.789 69.0391 182 68.5304 182 68",
    fill: "white"
  })), _path640 || (_path640 = /*#__PURE__*/React.createElement("path", {
    d: "M178 78V82H182V80C182 79.4696 181.789 78.9609 181.414 78.5858C181.039 78.2107 180.53 78 180 78",
    fill: "white"
  })), _path641 || (_path641 = /*#__PURE__*/React.createElement("path", {
    d: "M182 82H178V86H182V82Z",
    fill: "white"
  })), _path642 || (_path642 = /*#__PURE__*/React.createElement("path", {
    d: "M182 86H178V88C178 88.5304 178.211 89.0391 178.586 89.4142C178.961 89.7893 179.47 90 180 90C180.53 90 181.039 89.7893 181.414 89.4142C181.789 89.0391 182 88.5304 182 88",
    fill: "white"
  })), _path643 || (_path643 = /*#__PURE__*/React.createElement("path", {
    d: "M178 94V98H182V96C182 95.4696 181.789 94.9609 181.414 94.5858C181.039 94.2107 180.53 94 180 94",
    fill: "white"
  })), _path644 || (_path644 = /*#__PURE__*/React.createElement("path", {
    d: "M182 98H178V100C178 100.53 178.211 101.039 178.586 101.414C178.961 101.789 179.47 102 180 102C180.53 102 181.039 101.789 181.414 101.414C181.789 101.039 182 100.53 182 100",
    fill: "white"
  })), _path645 || (_path645 = /*#__PURE__*/React.createElement("path", {
    d: "M178 106V110H182V108C182 107.47 181.789 106.961 181.414 106.586C181.039 106.211 180.53 106 180 106",
    fill: "white"
  })), _path646 || (_path646 = /*#__PURE__*/React.createElement("path", {
    d: "M182 110H178V114H182V110Z",
    fill: "white"
  })), _path647 || (_path647 = /*#__PURE__*/React.createElement("path", {
    d: "M182 114H178V118H182V114Z",
    fill: "white"
  })), _path648 || (_path648 = /*#__PURE__*/React.createElement("path", {
    d: "M182 118H178V122H182V118Z",
    fill: "white"
  })), _path649 || (_path649 = /*#__PURE__*/React.createElement("path", {
    d: "M182 122H178V124C178 124.53 178.211 125.039 178.586 125.414C178.961 125.789 179.47 126 180 126C180.53 126 181.039 125.789 181.414 125.414C181.789 125.039 182 124.53 182 124",
    fill: "white"
  })), _path650 || (_path650 = /*#__PURE__*/React.createElement("path", {
    d: "M178 130V134H182V132C182 131.47 181.789 130.961 181.414 130.586C181.039 130.211 180.53 130 180 130",
    fill: "white"
  })), _path651 || (_path651 = /*#__PURE__*/React.createElement("path", {
    d: "M182 134H178V136C178 136.53 178.211 137.039 178.586 137.414C178.961 137.789 179.47 138 180 138C180.53 138 181.039 137.789 181.414 137.414C181.789 137.039 182 136.53 182 136",
    fill: "white"
  })), _path652 || (_path652 = /*#__PURE__*/React.createElement("path", {
    d: "M178 154H182V152C182 151.47 181.789 150.961 181.414 150.586C181.039 150.211 180.53 150 180 150C179.47 150 178.961 150.211 178.586 150.586C178.211 150.961 178 151.47 178 152",
    fill: "white"
  })), _path653 || (_path653 = /*#__PURE__*/React.createElement("path", {
    d: "M182 154H178V158H182V154Z",
    fill: "white"
  })), _path654 || (_path654 = /*#__PURE__*/React.createElement("path", {
    d: "M182 158H178V162H182V158Z",
    fill: "white"
  })), _path655 || (_path655 = /*#__PURE__*/React.createElement("path", {
    d: "M182 162H178V166H180C180.53 166 181.039 165.789 181.414 165.414C181.789 165.039 182 164.53 182 164",
    fill: "white"
  })), _path656 || (_path656 = /*#__PURE__*/React.createElement("path", {
    d: "M180 174C181.105 174 182 173.105 182 172C182 170.895 181.105 170 180 170C178.895 170 178 170.895 178 172C178 173.105 178.895 174 180 174Z",
    fill: "white"
  })), _path657 || (_path657 = /*#__PURE__*/React.createElement("path", {
    d: "M18 22H22V18H20C19.4696 18 18.9609 18.2107 18.5858 18.5858C18.2107 18.9609 18 19.4696 18 20",
    fill: "white"
  })), _path658 || (_path658 = /*#__PURE__*/React.createElement("path", {
    d: "M22 22H18V26H22V22Z",
    fill: "white"
  })), _path659 || (_path659 = /*#__PURE__*/React.createElement("path", {
    d: "M22 26H18V30H22V26Z",
    fill: "white"
  })), _path660 || (_path660 = /*#__PURE__*/React.createElement("path", {
    d: "M22 30H18V34H22V30Z",
    fill: "white"
  })), _path661 || (_path661 = /*#__PURE__*/React.createElement("path", {
    d: "M22 34H18V38H22V34Z",
    fill: "white"
  })), _path662 || (_path662 = /*#__PURE__*/React.createElement("path", {
    d: "M22 38H18V42H22V38Z",
    fill: "white"
  })), _path663 || (_path663 = /*#__PURE__*/React.createElement("path", {
    d: "M22 46V42H18V44C18 44.5304 18.2107 45.0391 18.5858 45.4142C18.9609 45.7893 19.4696 46 20 46",
    fill: "white"
  })), _path664 || (_path664 = /*#__PURE__*/React.createElement("path", {
    d: "M26 18H22V22H26V18Z",
    fill: "white"
  })), _path665 || (_path665 = /*#__PURE__*/React.createElement("path", {
    d: "M26 42H22V46H26V42Z",
    fill: "white"
  })), _path666 || (_path666 = /*#__PURE__*/React.createElement("path", {
    d: "M30 18H26V22H30V18Z",
    fill: "white"
  })), _path667 || (_path667 = /*#__PURE__*/React.createElement("path", {
    d: "M30 42H26V46H30V42Z",
    fill: "white"
  })), _path668 || (_path668 = /*#__PURE__*/React.createElement("path", {
    d: "M34 18H30V22H34V18Z",
    fill: "white"
  })), _path669 || (_path669 = /*#__PURE__*/React.createElement("path", {
    d: "M34 42H30V46H34V42Z",
    fill: "white"
  })), _path670 || (_path670 = /*#__PURE__*/React.createElement("path", {
    d: "M38 18H34V22H38V18Z",
    fill: "white"
  })), _path671 || (_path671 = /*#__PURE__*/React.createElement("path", {
    d: "M38 42H34V46H38V42Z",
    fill: "white"
  })), _path672 || (_path672 = /*#__PURE__*/React.createElement("path", {
    d: "M42 18H38V22H42V18Z",
    fill: "white"
  })), _path673 || (_path673 = /*#__PURE__*/React.createElement("path", {
    d: "M42 42H38V46H42V42Z",
    fill: "white"
  })), _path674 || (_path674 = /*#__PURE__*/React.createElement("path", {
    d: "M42 18V22H46V20C46 19.4696 45.7893 18.9609 45.4142 18.5858C45.0391 18.2107 44.5304 18 44 18",
    fill: "white"
  })), _path675 || (_path675 = /*#__PURE__*/React.createElement("path", {
    d: "M46 22H42V26H46V22Z",
    fill: "white"
  })), _path676 || (_path676 = /*#__PURE__*/React.createElement("path", {
    d: "M46 26H42V30H46V26Z",
    fill: "white"
  })), _path677 || (_path677 = /*#__PURE__*/React.createElement("path", {
    d: "M46 30H42V34H46V30Z",
    fill: "white"
  })), _path678 || (_path678 = /*#__PURE__*/React.createElement("path", {
    d: "M46 34H42V38H46V34Z",
    fill: "white"
  })), _path679 || (_path679 = /*#__PURE__*/React.createElement("path", {
    d: "M46 38H42V42H46V38Z",
    fill: "white"
  })), _path680 || (_path680 = /*#__PURE__*/React.createElement("path", {
    d: "M46 42H42V46H44C44.5304 46 45.0391 45.7893 45.4142 45.4142C45.7893 45.0391 46 44.5304 46 44",
    fill: "white"
  })), _path681 || (_path681 = /*#__PURE__*/React.createElement("path", {
    d: "M26 30H30V26H28C27.4696 26 26.9609 26.2107 26.5858 26.5858C26.2107 26.9609 26 27.4696 26 28",
    fill: "white"
  })), _path682 || (_path682 = /*#__PURE__*/React.createElement("path", {
    d: "M30 30H26V34H30V30Z",
    fill: "white"
  })), _path683 || (_path683 = /*#__PURE__*/React.createElement("path", {
    d: "M30 38V34H26V36C26 36.5304 26.2107 37.0391 26.5858 37.4142C26.9609 37.7893 27.4696 38 28 38",
    fill: "white"
  })), _path684 || (_path684 = /*#__PURE__*/React.createElement("path", {
    d: "M34 26H30V30H34V26Z",
    fill: "white"
  })), _path685 || (_path685 = /*#__PURE__*/React.createElement("path", {
    d: "M34 30H30V34H34V30Z",
    fill: "white"
  })), _path686 || (_path686 = /*#__PURE__*/React.createElement("path", {
    d: "M34 34H30V38H34V34Z",
    fill: "white"
  })), _path687 || (_path687 = /*#__PURE__*/React.createElement("path", {
    d: "M34 26V30H38V28C38 27.4696 37.7893 26.9609 37.4142 26.5858C37.0391 26.2107 36.5304 26 36 26",
    fill: "white"
  })), _path688 || (_path688 = /*#__PURE__*/React.createElement("path", {
    d: "M38 30H34V34H38V30Z",
    fill: "white"
  })), _path689 || (_path689 = /*#__PURE__*/React.createElement("path", {
    d: "M38 34H34V38H36C36.5304 38 37.0391 37.7893 37.4142 37.4142C37.7893 37.0391 38 36.5304 38 36",
    fill: "white"
  })), _path690 || (_path690 = /*#__PURE__*/React.createElement("path", {
    d: "M154 22H158V18H156C155.47 18 154.961 18.2107 154.586 18.5858C154.211 18.9609 154 19.4696 154 20",
    fill: "white"
  })), _path691 || (_path691 = /*#__PURE__*/React.createElement("path", {
    d: "M158 22H154V26H158V22Z",
    fill: "white"
  })), _path692 || (_path692 = /*#__PURE__*/React.createElement("path", {
    d: "M158 26H154V30H158V26Z",
    fill: "white"
  })), _path693 || (_path693 = /*#__PURE__*/React.createElement("path", {
    d: "M158 30H154V34H158V30Z",
    fill: "white"
  })), _path694 || (_path694 = /*#__PURE__*/React.createElement("path", {
    d: "M158 34H154V38H158V34Z",
    fill: "white"
  })), _path695 || (_path695 = /*#__PURE__*/React.createElement("path", {
    d: "M158 38H154V42H158V38Z",
    fill: "white"
  })), _path696 || (_path696 = /*#__PURE__*/React.createElement("path", {
    d: "M158 46V42H154V44C154 44.5304 154.211 45.0391 154.586 45.4142C154.961 45.7893 155.47 46 156 46",
    fill: "white"
  })), _path697 || (_path697 = /*#__PURE__*/React.createElement("path", {
    d: "M162 18H158V22H162V18Z",
    fill: "white"
  })), _path698 || (_path698 = /*#__PURE__*/React.createElement("path", {
    d: "M162 42H158V46H162V42Z",
    fill: "white"
  })), _path699 || (_path699 = /*#__PURE__*/React.createElement("path", {
    d: "M166 18H162V22H166V18Z",
    fill: "white"
  })), _path700 || (_path700 = /*#__PURE__*/React.createElement("path", {
    d: "M166 42H162V46H166V42Z",
    fill: "white"
  })), _path701 || (_path701 = /*#__PURE__*/React.createElement("path", {
    d: "M170 18H166V22H170V18Z",
    fill: "white"
  })), _path702 || (_path702 = /*#__PURE__*/React.createElement("path", {
    d: "M170 42H166V46H170V42Z",
    fill: "white"
  })), _path703 || (_path703 = /*#__PURE__*/React.createElement("path", {
    d: "M174 18H170V22H174V18Z",
    fill: "white"
  })), _path704 || (_path704 = /*#__PURE__*/React.createElement("path", {
    d: "M174 42H170V46H174V42Z",
    fill: "white"
  })), _path705 || (_path705 = /*#__PURE__*/React.createElement("path", {
    d: "M178 18H174V22H178V18Z",
    fill: "white"
  })), _path706 || (_path706 = /*#__PURE__*/React.createElement("path", {
    d: "M178 42H174V46H178V42Z",
    fill: "white"
  })), _path707 || (_path707 = /*#__PURE__*/React.createElement("path", {
    d: "M178 18V22H182V20C182 19.4696 181.789 18.9609 181.414 18.5858C181.039 18.2107 180.53 18 180 18",
    fill: "white"
  })), _path708 || (_path708 = /*#__PURE__*/React.createElement("path", {
    d: "M182 22H178V26H182V22Z",
    fill: "white"
  })), _path709 || (_path709 = /*#__PURE__*/React.createElement("path", {
    d: "M182 26H178V30H182V26Z",
    fill: "white"
  })), _path710 || (_path710 = /*#__PURE__*/React.createElement("path", {
    d: "M182 30H178V34H182V30Z",
    fill: "white"
  })), _path711 || (_path711 = /*#__PURE__*/React.createElement("path", {
    d: "M182 34H178V38H182V34Z",
    fill: "white"
  })), _path712 || (_path712 = /*#__PURE__*/React.createElement("path", {
    d: "M182 38H178V42H182V38Z",
    fill: "white"
  })), _path713 || (_path713 = /*#__PURE__*/React.createElement("path", {
    d: "M182 42H178V46H180C180.53 46 181.039 45.7893 181.414 45.4142C181.789 45.0391 182 44.5304 182 44",
    fill: "white"
  })), _path714 || (_path714 = /*#__PURE__*/React.createElement("path", {
    d: "M162 30H166V26H164C163.47 26 162.961 26.2107 162.586 26.5858C162.211 26.9609 162 27.4696 162 28",
    fill: "white"
  })), _path715 || (_path715 = /*#__PURE__*/React.createElement("path", {
    d: "M166 30H162V34H166V30Z",
    fill: "white"
  })), _path716 || (_path716 = /*#__PURE__*/React.createElement("path", {
    d: "M166 38V34H162V36C162 36.5304 162.211 37.0391 162.586 37.4142C162.961 37.7893 163.47 38 164 38",
    fill: "white"
  })), _path717 || (_path717 = /*#__PURE__*/React.createElement("path", {
    d: "M170 26H166V30H170V26Z",
    fill: "white"
  })), _path718 || (_path718 = /*#__PURE__*/React.createElement("path", {
    d: "M170 30H166V34H170V30Z",
    fill: "white"
  })), _path719 || (_path719 = /*#__PURE__*/React.createElement("path", {
    d: "M170 34H166V38H170V34Z",
    fill: "white"
  })), _path720 || (_path720 = /*#__PURE__*/React.createElement("path", {
    d: "M170 26V30H174V28C174 27.4696 173.789 26.9609 173.414 26.5858C173.039 26.2107 172.53 26 172 26",
    fill: "white"
  })), _path721 || (_path721 = /*#__PURE__*/React.createElement("path", {
    d: "M174 30H170V34H174V30Z",
    fill: "white"
  })), _path722 || (_path722 = /*#__PURE__*/React.createElement("path", {
    d: "M174 34H170V38H172C172.53 38 173.039 37.7893 173.414 37.4142C173.789 37.0391 174 36.5304 174 36",
    fill: "white"
  })), _path723 || (_path723 = /*#__PURE__*/React.createElement("path", {
    d: "M18 158H22V154H20C19.4696 154 18.9609 154.211 18.5858 154.586C18.2107 154.961 18 155.47 18 156",
    fill: "white"
  })), _path724 || (_path724 = /*#__PURE__*/React.createElement("path", {
    d: "M22 158H18V162H22V158Z",
    fill: "white"
  })), _path725 || (_path725 = /*#__PURE__*/React.createElement("path", {
    d: "M22 162H18V166H22V162Z",
    fill: "white"
  })), _path726 || (_path726 = /*#__PURE__*/React.createElement("path", {
    d: "M22 166H18V170H22V166Z",
    fill: "white"
  })), _path727 || (_path727 = /*#__PURE__*/React.createElement("path", {
    d: "M22 170H18V174H22V170Z",
    fill: "white"
  })), _path728 || (_path728 = /*#__PURE__*/React.createElement("path", {
    d: "M22 174H18V178H22V174Z",
    fill: "white"
  })), _path729 || (_path729 = /*#__PURE__*/React.createElement("path", {
    d: "M22 182V178H18V180C18 180.53 18.2107 181.039 18.5858 181.414C18.9609 181.789 19.4696 182 20 182",
    fill: "white"
  })), _path730 || (_path730 = /*#__PURE__*/React.createElement("path", {
    d: "M26 154H22V158H26V154Z",
    fill: "white"
  })), _path731 || (_path731 = /*#__PURE__*/React.createElement("path", {
    d: "M26 178H22V182H26V178Z",
    fill: "white"
  })), _path732 || (_path732 = /*#__PURE__*/React.createElement("path", {
    d: "M30 154H26V158H30V154Z",
    fill: "white"
  })), _path733 || (_path733 = /*#__PURE__*/React.createElement("path", {
    d: "M30 178H26V182H30V178Z",
    fill: "white"
  })), _path734 || (_path734 = /*#__PURE__*/React.createElement("path", {
    d: "M34 154H30V158H34V154Z",
    fill: "white"
  })), _path735 || (_path735 = /*#__PURE__*/React.createElement("path", {
    d: "M34 178H30V182H34V178Z",
    fill: "white"
  })), _path736 || (_path736 = /*#__PURE__*/React.createElement("path", {
    d: "M38 154H34V158H38V154Z",
    fill: "white"
  })), _path737 || (_path737 = /*#__PURE__*/React.createElement("path", {
    d: "M38 178H34V182H38V178Z",
    fill: "white"
  })), _path738 || (_path738 = /*#__PURE__*/React.createElement("path", {
    d: "M42 154H38V158H42V154Z",
    fill: "white"
  })), _path739 || (_path739 = /*#__PURE__*/React.createElement("path", {
    d: "M42 178H38V182H42V178Z",
    fill: "white"
  })), _path740 || (_path740 = /*#__PURE__*/React.createElement("path", {
    d: "M42 154V158H46V156C46 155.47 45.7893 154.961 45.4142 154.586C45.0391 154.211 44.5304 154 44 154",
    fill: "white"
  })), _path741 || (_path741 = /*#__PURE__*/React.createElement("path", {
    d: "M46 158H42V162H46V158Z",
    fill: "white"
  })), _path742 || (_path742 = /*#__PURE__*/React.createElement("path", {
    d: "M46 162H42V166H46V162Z",
    fill: "white"
  })), _path743 || (_path743 = /*#__PURE__*/React.createElement("path", {
    d: "M46 166H42V170H46V166Z",
    fill: "white"
  })), _path744 || (_path744 = /*#__PURE__*/React.createElement("path", {
    d: "M46 170H42V174H46V170Z",
    fill: "white"
  })), _path745 || (_path745 = /*#__PURE__*/React.createElement("path", {
    d: "M46 174H42V178H46V174Z",
    fill: "white"
  })), _path746 || (_path746 = /*#__PURE__*/React.createElement("path", {
    d: "M46 178H42V182H44C44.5304 182 45.0391 181.789 45.4142 181.414C45.7893 181.039 46 180.53 46 180",
    fill: "white"
  })), _path747 || (_path747 = /*#__PURE__*/React.createElement("path", {
    d: "M26 166H30V162H28C27.4696 162 26.9609 162.211 26.5858 162.586C26.2107 162.961 26 163.47 26 164",
    fill: "white"
  })), _path748 || (_path748 = /*#__PURE__*/React.createElement("path", {
    d: "M30 166H26V170H30V166Z",
    fill: "white"
  })), _path749 || (_path749 = /*#__PURE__*/React.createElement("path", {
    d: "M30 174V170H26V172C26 172.53 26.2107 173.039 26.5858 173.414C26.9609 173.789 27.4696 174 28 174",
    fill: "white"
  })), _path750 || (_path750 = /*#__PURE__*/React.createElement("path", {
    d: "M34 162H30V166H34V162Z",
    fill: "white"
  })), _path751 || (_path751 = /*#__PURE__*/React.createElement("path", {
    d: "M34 166H30V170H34V166Z",
    fill: "white"
  })), _path752 || (_path752 = /*#__PURE__*/React.createElement("path", {
    d: "M34 170H30V174H34V170Z",
    fill: "white"
  })), _path753 || (_path753 = /*#__PURE__*/React.createElement("path", {
    d: "M34 162V166H38V164C38 163.47 37.7893 162.961 37.4142 162.586C37.0391 162.211 36.5304 162 36 162",
    fill: "white"
  })), _path754 || (_path754 = /*#__PURE__*/React.createElement("path", {
    d: "M38 166H34V170H38V166Z",
    fill: "white"
  })), _path755 || (_path755 = /*#__PURE__*/React.createElement("path", {
    d: "M38 170H34V174H36C36.5304 174 37.0391 173.789 37.4142 173.414C37.7893 173.039 38 172.53 38 172",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2312_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M200 0H0V200H200V0Z",
    fill: "#1D2428",
    fillOpacity: 0.8
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 75,
    y: 78,
    width: 50,
    height: 44,
    fill: "url(#pattern0_2312_2)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_2312_2",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_2312_2",
    transform: "scale(0.00591716 0.00675676)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2312_2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 200,
    height: 200,
    fill: "white"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_2312_2",
    width: 169,
    height: 148,
    xlinkHref: "data:image/png;base64,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"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApple);
export default __webpack_public_path__ + "static/media/apple.b51060ec468ac3f02f6255effdabc52b.svg";
export { ForwardRef as ReactComponent };